export default {
  // Sprachoptionen
  lang: {
    zh: '简体中文',
    en: 'English',
    de: 'Deutsch',
  },

  // Navigation
  nav: {
    home: 'Startseite',
    marketArea: 'Marktbereich',
    productCenter: 'Produkte',
    serviceSupport: 'Service & Support',
    news: 'Neuigkeiten',
    contactUs: 'Kontakt',
  },

  // Footer
  footer: {
    followUs: 'Folgen & Kontaktieren Sie uns',
    email: 'E-Mail: info-am@melonbean.com',
    address: 'Adresse: Nr.5 Dongli South Road, Torch Development Zone, Zhongshan, Guangdong',
    home: 'Startseite',
    marketArea: 'Marktbereich',
    productCenter: 'Produkte',
    serviceSupport: 'Service & Support',
    contactUs: 'Kontakt',
    market: {
      chemical: 'Chemie',
      spaceflight: 'Luft- & Raumfahrt',
      electron: 'Elektronik',
      AI: 'KI',
      transportation: 'Transport',
      newEnergy: 'Erneuerbare Energie',
      architecture: 'Architektur',
      homeAppliances: 'Haushaltsgeräte',
    },
    product: {
      heatConduction: 'Wärmeleitung',
      heatInsulation: 'Wärmedämmung & Nano-Platte',
      thermalInsulation: 'Thermische Isolierung',
      fireproof: 'Feuerfest / Hochtemperaturbeschichtung',
      insulation: 'Isolierung',
      electricHeating: 'Elektrische Heizung',
      dielectric: 'Dielektrikum',
      electricConduction: 'Elektrische Leitung',
    },
    contact: {
      contactInfo: 'Kontaktinformationen',
      companyAddress: 'Unternehmensadresse',
      joinUs: 'Stellen Sie sich vor',
    },
    copyright: '© 2025 Melonbean Innovative Materials Co., Ltd. Alle Rechte vorbehalten',
  },

  // Home
  home: {
    bannerTitle: 'Ein besseres Leben mit Materialien schaffen',
    bannerSubtitle: 'Create a better life with materials',
    companyTitle: 'Unternehmensprofil',
    companyIntro: 'Melonbean (Deutschland) Innovative Materials Co., Ltd. wurde im Januar 2019 gegründet. Mit Niederlassungen weltweit befindet sich unser F&E-Hauptsitz in Deutschland und wir haben ein lokales F&E-Zentrum in China. Das Unternehmen widmet sich der Entwicklung und Anwendung innovativer thermoelektrischer Managementmaterialien für Wärmedämmung, Wärmeisolierung, Wärmespeicherung, Wärmeleitfähigkeit, elektrische Heizung, Brandschutz, Isolierung, elektrische Leitfähigkeit und antistatische Lösungen.',
    companyIntro2:'',
    culture: 'Unternehmenskultur',
    mission: 'Mission',
    missionInfo: 'Ein besseres Leben mit Materialien schaffen',
    vision: 'Vision',
    visionInfo: 'Bevorzugter Partner für thermoelektrische Funktionsmaterialien',
    value: 'Werte',
    valueInfo: 'Wahrheit aus Fakten suchen',
    productTitle: 'Produkte',
    viewAll: 'Alle anzeigen →',
    moreInfo: 'Mehr Info',
    solutionTitle: 'Lösungen',
    newsTitle: 'Nachrichtenzentrum',
    news: {
      article1: "Dämmbeschichtung (λ=0,028) bei großen Inlandskunden im Einsatz.",
      article2: "Brandschutzdämmbeschichtung für Flugzeugtankschutz.",
      article3: "Thermische PCM in Servern & KI-Geräten massenhaft verbaut.",
      article4: 'Hochtemperatur-Dämmstoff für Turbolader von Dieselmotoren.',
      article5: '3W & 5W Wärmeleitpads, Serieneinsatz für Server',


    },
    products: {
      fireproof: {
        title: 'Brandschutzbeschichtung',
        content: 'Hochtemperaturbeständige Beschichtung auf Basis organisch-anorganischer Hybrid-Silikonharze. Kurzfristig bis 2000°C und langfristig bis 650°C beständig.',
      },
      thermalInsulation: {
        title: 'Wärmedämmbeschichtung',
        content: 'Aufgetragen durch Sprühverfahren auf Metall, anorganische und Kunststoffsubstrate. Wärmeleitfähigkeit ab 0,025 W/m·K mit Silica-Aerogel als Hauptdämmfüller.',
      },
      dielectricCoating: {
        title: 'Isolierbeschichtung',
        content: 'Hochtemperatur-Isolierbeschichtung mit Dauerbeständigkeit bis 300°C. Geeignet für Elektrofahrzeuge, Stromversorgung und elektrische Heizanwendungen.',
      },
      heatConduction: {
        title: 'Wärmeleitung',
        content: 'Wärmeleitende Schnittstellenmaterialien für Chips und Wärmeerzeuger. Umfasst Wärmeleitpads, Gele, Phasenwechselfolien, Wärmeleitpasten, Klebebänder und Graphitfolien.',
      },
      nanoBoard: {
        title: 'Nano-Dämmplatte',
        content: 'Nano-Dämmplatten blockieren alle Wärmeübertragungspfade effektiv. Wärmeleitfähigkeit niedriger als Luft bei niedrigen Temperaturen und niedriger als Aerogel bei hohen Temperaturen.',
      },
      electricConduction: {
        title: 'Elektrische Leitung',
        content: 'Graphenbasierte Leitbeschichtungen bieten hervorragende elektrische Leitfähigkeit und Widerstandserwärmung. Beide Typen arbeiten dauerhaft bei bis zu 300°C.',
      },
      electricHeating: {
        title: 'Elektrische Heizung',
        content: 'Verwendet Leitbeschichtungen zur Wärmeerzeugung. Kompatibel mit Metall, Glas und Kunststoff. Aufgetragen durch Sprühen oder Siebdruck, dann bei hohen Temperaturen ausgehärtet.',
      },
      heatInsulation: {
        title: 'Wärmeisolierung',
        content: 'Aerogel-Isolierfolie bietet hervorragende Wärmedämmung zum Schutz wärmeempfindlicher Komponenten in der Unterhaltungselektronik und verlängert die Produktlebensdauer.',
      },
      dielectric: {
        title: 'Isolation',
        content: 'Hochtemperatur-Isolierbeschichtung mit Dauerbeständigkeit bis 300°C und kurzfristiger Flammbeständigkeit von mehreren tausend Grad bei gleichzeitig hervorragenden elektrischen Isoliereigenschaften.',
      },
    },
    solutions: {
      spaceflight: 'Luft- & Raumfahrt',
      chemical: 'Chemie',
      electron: 'Elektronik',
      transportation: 'Transport',
      newEnergy: 'Erneuerbare Energie',
      AI: 'KI',
      architecture: 'Architektur',
      homeAppliances: 'Haushaltsgeräte',
    },
  },

  // Market Area
  marketArea: {
    bannerTitle: 'Marktbereich',
    title: 'Marktbereich',
    more: 'Mehr',
    exploreMore: 'Weitere Anwendungen erkunden',
    breadcrumbMarketArea: 'Marktbereich',
    characteristics: {
      heatConduction: 'Wärmeleitung',
      heatInsulation: 'Wärmedämmung',
      dielectric: 'Dielektrikum',
      electricConduction: 'Elektrische Leitung',
      thermalInsulation: 'Thermische Isolierung',
      fireproof: 'Feuerfest'
    },
    list: {
      chemical: { 
        title: 'Chemie', 
        content: 'Die Erdöl- und Petrochemieindustrie ist die wichtigste Energiequelle für Länder auf der ganzen Welt. Statistiken zeigen, dass Erdöl und Petrochemikalien jährlich 25% aller Wärmedämmmaterialien verwenden. Große Mengen von Rohrleitungen und Wärmeanlagen benötigen Wärmedämmung und Kühldämmung. Derzeit variieren Status und technisches Niveau der Wärme- und Kühldämmung stark, und das technische Niveau hängt direkt mit Kapazitätsaufbau, Kosten und Umweltschutz zusammen. Melonbean hat viele Fälle in Wärmedämmung und Brandschutz und bietet überlegene Materialien, um die Erdöl- und Petrochemieindustrie besser zu bedienen.'
      },
      spaceflight: { 
        title: 'Luft- & Raumfahrt', 
        content: 'In den letzten Jahren hat sich die Luft- und Raumfahrt rasant entwickelt, und luft- und raumfahrtbezogene Materialien haben sich ebenfalls schnell entwickelt, während sie mehr Anforderungen an Materialien stellen. Raumfahrzeug-Wärmemanagementsysteme verwenden umfassend Wärmedämmmaterialien, wärmeleitende Materialien, Beschichtungen und wärmeleitende Füllstoffe, die alle material-thermophysikalische Eigenschaften nutzen, um Raumfahrzeug-Temperaturfelder zu kontrollieren. In Zukunft, da die menschliche Erforschung des Weltraums häufiger wird, stehen Materialien vor strengeren Anforderungen wie hochzuverlässige Materialien, leichte Materialien, multifunktionale Verbundmaterialien, extreme temperaturbeständige Materialien und intelligente Wärmekontrollmaterialien. Melonbean hat tiefe Forschung und Akkumulation in Wärmedämmung und Brandschutz und bietet spezielle Materialoptionen.'
      },
      electron: { 
        title: 'Elektronik', 
        content: 'Im Zeitalter der Elektronikprodukt-Explosion mit diversifizierten und komplexen Funktionen und Anforderungen, gekoppelt mit KI-Rechenleistung, streben Elektronikprodukt-Designer/Nutzer kleinere, dünnere, leichtere, schnellere und zuverlässigere Elektronikprodukte an, sei es Smartphones, Laptops, Wearables, IoT-Geräte, einschließlich aktueller humanoider Roboter. Die Datenverarbeitungs- und Speicherkapazität elektronischer Produkte steigt rapide an und erfordert höheres umfassendes Wärmemanagement einschließlich Wärmeleitung, Wärmeableitung, thermischer Gleichmäßigkeit und Wärmeisolierung, um Geräteanforderungen zu erfüllen. Melonbean kann verschiedene Produkte anpassen, um unterschiedliche Bedürfnisse zu erfüllen und die Leistung elektronischer Produkte zu verbessern.'
      },
      AI: { 
        title: 'KI', 
        content: 'Mit dem Aufkommen des KI-Zeitalters entstehen verschiedene große Modelle, große Berechnungen und große Datenspeicherung. Chip-Berechnungen nehmen zu mit höheren Frequenzanforderungen, aber Produkt- und Designraum wird kleiner, was dazu führt, dass Leistungsdichte und Wärmeflussdichte elektronischer Komponenten in KI-Geräten dramatisch ansteigen. Wärmemanagement-Herausforderungen wachsen und treiben die Entwicklung verschiedener Wärmemanagement-Produkte wie Graphen, ultradünne VC und Flüssigkühlung voran. Melonbean kann Wärmemanagement-Materialien mit verschiedenen Leistungsmerkmalen (Wärmeschnittstellenmaterialien, Wärmedämmmaterialien, leitend, isolierend) bereitstellen, um den Bedürfnissen der KI-Industrie gerecht zu werden.'
      },
      transportation: { 
        title: 'Transport', 
        content: 'Traditioneller Transport wird durch intelligenten Transport ersetzt, wie Japans Shinkansen und Chinas CRH, wobei mehr Städte U-Bahn-Systeme bauen. Die Anforderungen der Menschen an den Transport steigen allmählich. Forschung und Entwicklung neuer Transportmaterialien zielt darauf ab, Fahrzeugleistung, Sicherheit und Umweltfreundlichkeit zu verbessern. Diese Materialien umfassen leichte Legierungen, Kohlefaser-Verbundwerkstoffe, hochfeste Stähle und nanotechnologie-modifizierte Materialien. Durch die Verwendung dieser Materialien können Fahrzeuge Gewichtsreduzierung, geringeren Energieverbrauch, reduzierte Emissionen und verlängerte Lebensdauer erreichen. Zusätzlich fördert die Anwendung dieser Materialien Transportdesign-Innovation und verbessert Leistung und Ästhetik.'
      },
      newEnergy: { 
        title: 'Erneuerbare Energie', 
        content: 'Vor dem Hintergrund der globalen Erwärmung haben Länder begonnen, erneuerbare Energieindustrien (Elektrofahrzeuge, Brennstoffzellenfahrzeuge, Energiespeicherung, Windenergie, Photovoltaik) energisch zu entwickeln. Diese neuen Industrien fördern Gesellschaft und persönliches Leben erheblich und stärken die Entschlossenheit der Menschen, den Kampf gegen CO2 zu gewinnen. Diese Industrien Nachfrage nach neuen Materialien ist zunehmend stark. Elektrofahrzeug-Batteriepacks und Energiespeichersystem-Batteriepacks haben komplexere und anspruchsvollere Wärmemanagement-Anforderungen mit höheren Anforderungen an Brandschutz, Wärmedämmung und elektrische Isolierung, was mehr Leistungs- und Zuverlässigkeitsanforderungen an Materialien stellt. Melonbean beteiligt sich aktiv am Bereich erneuerbare Energien mit vielen positiven und nützlichen Versuchen und sammelt reiche Branchenerfahrung.'
      },
      architecture: { 
        title: 'Architektur', 
        content: 'Bei der kontinuierlichen Förderung der Gebäudeenergieeffizienz haben Bau- und Dekorationsunternehmen und Immobilienentwickler hohe Anforderungen an Wärmedämmung und Brandbeständigkeit von Gebäudedämmstoffen gestellt und streben an, den Energieverbrauch erheblich zu reduzieren und damit Umweltverschmutzung und Treibhauseffekte zu verringern. Die Verwendung guter Isoliermaterialien in der Industrie hilft, Produktenergieverbrauch und Produktionskosten zu reduzieren und bietet große gesellschaftliche Vorteile. Bauindustrie-Entwicklungstrends umfassen Außenwand-Dämmung, Leichtbau-Entwicklung, grüne Entwicklung, funktionale Diversifizierung und Anforderungen für transparente Isoliermaterialien. Melonbeans Wärmedämm- und Brandschutzmaterialien können Industrieanforderungen erfüllen und den globalen Umweltschutz unterstützen.'
      },
      homeAppliances: { 
        title: 'Haushaltsgeräte', 
        content: 'Da sich der globale Lebensstandard verbessert, haben Menschen zunehmend professionelle und raffinierte Anforderungen an Haushaltsgeräte mit mehr funktionalen Anforderungen wie Heißluftfritteusen, Öfen, Geschirrspülern und vielen Produkten, die Internetkonnektivität erfordern, wie Smart-TVs und Kühlschränke. Daher steigen die Anforderungen an verschiedene funktionale Materialien, was Melonbeans Fachgebiet ist.'
      },
    },
    pages: {
      chemical: {
        title: 'Chemie',
        content: 'Die Erdöl- und Petrochemieindustrie ist die wichtigste Energiequelle für Länder auf der ganzen Welt. Statistiken zeigen, dass Erdöl und Petrochemikalien jährlich 25% aller Wärmedämmmaterialien verwenden. Große Mengen von Rohrleitungen und Wärmeanlagen benötigen Wärmedämmung und Kühldämmung. Derzeit variieren Status und technisches Niveau der Wärme- und Kühldämmung stark, und das technische Niveau hängt direkt mit Kapazitätsaufbau, Kosten und Umweltschutz zusammen. Melonbean hat viele Fälle in Wärmedämmung und Brandschutz und bietet überlegene Materialien, um die Erdöl- und Petrochemieindustrie besser zu bedienen.'
      },
      spaceflight: {
        title: 'Luft- & Raumfahrt',
        content: 'In den letzten Jahren hat sich die Luft- und Raumfahrt rasant entwickelt, und luft- und raumfahrtbezogene Materialien haben sich ebenfalls schnell entwickelt, während sie mehr Anforderungen an Materialien stellen. Raumfahrzeug-Wärmemanagementsysteme verwenden umfassend Wärmedämmmaterialien, wärmeleitende Materialien, Beschichtungen und wärmeleitende Füllstoffe, die alle material-thermophysikalische Eigenschaften nutzen, um Raumfahrzeug-Temperaturfelder zu kontrollieren. In Zukunft, da die menschliche Erforschung des Weltraums häufiger wird, stehen Materialien vor strengeren Anforderungen wie hochzuverlässige Materialien, leichte Materialien, multifunktionale Verbundmaterialien, extreme temperaturbeständige Materialien und intelligente Wärmekontrollmaterialien. Melonbean hat tiefe Forschung und Akkumulation in Wärmedämmung und Brandschutz und bietet spezielle Materialoptionen.'
      },
      electron: {
        title: 'Elektronik',
        content: 'Im Zeitalter der Elektronikprodukt-Explosion mit diversifizierten und komplexen Funktionen und Anforderungen, gekoppelt mit KI-Rechenleistung, streben Elektronikprodukt-Designer/Nutzer kleinere, dünnere, leichtere, schnellere und zuverlässigere Elektronikprodukte an, sei es Smartphones, Laptops, Wearables, IoT-Geräte, einschließlich aktueller humanoider Roboter. Die Datenverarbeitungs- und Speicherkapazität elektronischer Produkte steigt rapide an und erfordert höheres umfassendes Wärmemanagement einschließlich Wärmeleitung, Wärmeableitung, thermischer Gleichmäßigkeit und Wärmeisolierung, um Geräteanforderungen zu erfüllen. Melonbean kann verschiedene Produkte anpassen, um unterschiedliche Bedürfnisse zu erfüllen und die Leistung elektronischer Produkte zu verbessern.'
      },
      AI: {
        title: 'KI',
        content: 'Mit dem Aufkommen des KI-Zeitalters entstehen verschiedene große Modelle, große Berechnungen und große Datenspeicherung. Chip-Berechnungen nehmen zu mit höheren Frequenzanforderungen, aber Produkt- und Designraum wird kleiner, was dazu führt, dass Leistungsdichte und Wärmeflussdichte elektronischer Komponenten in KI-Geräten dramatisch ansteigen. Wärmemanagement-Herausforderungen wachsen und treiben die Entwicklung verschiedener Wärmemanagement-Produkte wie Graphen, ultradünne VC und Flüssigkühlung voran. Melonbean kann Wärmemanagement-Materialien mit verschiedenen Leistungsmerkmalen (Wärmeschnittstellenmaterialien, Wärmedämmmaterialien, leitend, isolierend) bereitstellen, um den Bedürfnissen der KI-Industrie gerecht zu werden.'
      },
      transportation: {
        title: 'Transport',
        content: 'Traditioneller Transport wird durch intelligenten Transport ersetzt, wie Japans Shinkansen und Chinas CRH, wobei mehr Städte U-Bahn-Systeme bauen. Die Anforderungen der Menschen an den Transport steigen allmählich. Forschung und Entwicklung neuer Transportmaterialien zielt darauf ab, Fahrzeugleistung, Sicherheit und Umweltfreundlichkeit zu verbessern. Diese Materialien umfassen leichte Legierungen, Kohlefaser-Verbundwerkstoffe, hochfeste Stähle und nanotechnologie-modifizierte Materialien. Durch die Verwendung dieser Materialien können Fahrzeuge Gewichtsreduzierung, geringeren Energieverbrauch, reduzierte Emissionen und verlängerte Lebensdauer erreichen. Zusätzlich fördert die Anwendung dieser Materialien Transportdesign-Innovation und verbessert Leistung und Ästhetik.'
      },
      newEnergy: {
        title: 'Erneuerbare Energie',
        content: 'Vor dem Hintergrund der globalen Erwärmung haben Länder begonnen, erneuerbare Energieindustrien (Elektrofahrzeuge, Brennstoffzellenfahrzeuge, Energiespeicherung, Windenergie, Photovoltaik) energisch zu entwickeln. Diese neuen Industrien fördern Gesellschaft und persönliches Leben erheblich und stärken die Entschlossenheit der Menschen, den Kampf gegen CO2 zu gewinnen. Diese Industrien Nachfrage nach neuen Materialien ist zunehmend stark. Elektrofahrzeug-Batteriepacks und Energiespeichersystem-Batteriepacks haben komplexere und anspruchsvollere Wärmemanagement-Anforderungen mit höheren Anforderungen an Brandschutz, Wärmedämmung und elektrische Isolierung, was mehr Leistungs- und Zuverlässigkeitsanforderungen an Materialien stellt. Melonbean beteiligt sich aktiv am Bereich erneuerbare Energien mit vielen positiven und nützlichen Versuchen und sammelt reiche Branchenerfahrung.'
      },
      architecture: {
        title: 'Architektur',
        content: 'Bei der kontinuierlichen Förderung der Gebäudeenergieeffizienz haben Bau- und Dekorationsunternehmen und Immobilienentwickler hohe Anforderungen an Wärmedämmung und Brandbeständigkeit von Gebäudedämmstoffen gestellt und streben an, den Energieverbrauch erheblich zu reduzieren und damit Umweltverschmutzung und Treibhauseffekte zu verringern. Die Verwendung guter Isoliermaterialien in der Industrie hilft, Produktenergieverbrauch und Produktionskosten zu reduzieren und bietet große gesellschaftliche Vorteile. Bauindustrie-Entwicklungstrends umfassen Außenwand-Dämmung, Leichtbau-Entwicklung, grüne Entwicklung, funktionale Diversifizierung und Anforderungen für transparente Isoliermaterialien. Melonbeans Wärmedämm- und Brandschutzmaterialien können Industrieanforderungen erfüllen und den globalen Umweltschutz unterstützen.'
      },
      homeAppliances: {
        title: 'Haushaltsgeräte',
        content: 'Da sich der globale Lebensstandard verbessert, haben Menschen zunehmend professionelle und raffinierte Anforderungen an Haushaltsgeräte mit mehr funktionalen Anforderungen wie Heißluftfritteusen, Öfen, Geschirrspülern und vielen Produkten, die Internetkonnektivität erfordern, wie Smart-TVs und Kühlschränke. Daher steigen die Anforderungen an verschiedene funktionale Materialien, was Melonbeans Fachgebiet ist.'
      }
    }
  },

  // Product Center
  productCenter: {
    bannerTitle: 'Produktzentrum',
    title: 'Produktzentrum',
    more: 'Mehr',
    breadcrumbProductCenter: 'Produktzentrum',
    breadcrumbProductInfo: 'Produktdetails',
    productDetail: 'Produktdetails',
    downloadManual: 'Produkthandbuch herunterladen',
    contactForMore: 'Für weitere Produktinformationen kontaktieren Sie bitte unser Vertriebsteam und lokale Kanäle',
    
    // Produktliste
    products: {
      heatConduction: {
        name: 'Wärmeleitung',
        content: 'Wärmeschnittstellenmaterialien werden hauptsächlich an Chips und anderen wärmeerzeugenden Komponenten verwendet, um Lücken zu füllen und Wärme schnell abzuleiten, Probleme mit Chips und anderen wärmeerzeugenden Geräten zu reduzieren und gleichzeitig die langfristige Zuverlässigkeit von Chips und anderen Komponenten zu gewährleisten. Wärmematerialien sind eine Serie von Materialien einschließlich Wärmeleitpads, Wärmegele, Phasenwechselfolien, Wärmeleitpasten, Wärmebänder und Graphitfolien, die weit verbreitet in Elektronik, Telekommunikation, Automobil, Industrie und anderen Branchen verwendet werden.'
      },
      nanoBoard: {
        name: 'Nano-Dämmplatte',
        content: 'Nano-Dämmplatten haben spezielle Designs, die Wärmeübertragungspfade (Wärmeleitung, Wärmekonvektion, Wärmestrahlung) effektiv blockieren, um ausgezeichnete Dämmeffekte zu erzielen. Das Produkt basiert auf Nanomaterialien, ergänzt durch Hochtemperatur-Verstärkung und Hochtemperatur-Dämmkomponenten, verarbeitet mit speziellen Formgebungstechniken. Nano-Dämmplatten haben bei niedrigen Temperaturen eine geringere Wärmeleitfähigkeit als Luft und bei hohen Temperaturen niedriger als Aerogel, mit extrem hoher thermischer Stabilität und überlegener Thermoschockbeständigkeit. Die Dämmleistung von Nano-Dämmplatten ist mehrfach höher als die von traditionellen Materialien und macht sie zu idealen Hochtemperatur-Dämmstoffen auf dem Markt.'
      },
      thermalInsulation: {
        name: 'Wärmedämmung',
        content: 'Wärmedämmbeschichtungen werden hauptsächlich durch Sprühen auf Substrate aufgetragen, die Wärmedämmung benötigen, einschließlich Metalle, anorganische Stoffe und Kunststoffe, besonders geeignet für unregelmäßige Positionen. Wärmedämmbeschichtungen haben eine Wärmeleitfähigkeit von nur 0,025w/m.k, mit Silica-Aerogel als Hauptdämmfüller. Für verschiedene Arbeitstemperaturen werden verschiedene Hybridisierungsverhältnisse organisch-anorganischer Hybridsysteme verwendet, um den Temperaturbereich von -40°C bis zu 1000°C zu erfüllen.'
      },
      fireproof: {
        name: 'Beschichtungen',
        content: 'Hochtemperaturbeständige Beschichtungen basierend auf organisch-anorganischen Hybrid-Silikonharzen als Hauptkomponente, mit ausgezeichneter Hochtemperaturbeständigkeit. Mit geeigneten Füllstoffen können sie kurzfristige Temperaturbeständigkeit über 2000°C und langfristige Arbeitstemperatur von 650°C erreichen. Klarlacke ohne Pigmentfüller können auch maximale Temperaturbeständigkeit von 1000°C auf Edelstahlplatten erreichen. Einige Beschichtungen haben Funktionen zur Verlangsamung der Edelstahloxidation bei hohen Temperaturen; andere haben ausgezeichnete Korrosionsschutzeigenschaften. Zusätzlich haben die meisten dieser Produkte hohe Härteeigenschaften und bieten ausgezeichnete Verschleiß- und Kratzfestigkeit.'
      },
      heatInsulation: {
        name: 'Wärmeisolierung',
        content: 'Aerogel-Isolierfolie wird durch spezielle Techniken verarbeitet, um Nano-Aerogel zu dünnen Filmen zu formen und ausgezeichnete Isolierleistung zu bieten, um Hotspot-Probleme in begrenzten Räumen von Verbrauchselektronik zu lösen und Isolierschutz für wärmeempfindliche Komponenten zu bieten, wodurch Produktlebensdauer und -leistung verbessert werden. Nano-Aerogel-Isolierfolien blockieren die Wärmeübertragungsrichtung durch Aerogel-Nanolücken, reduzieren die Produktoberflächentemperatur und eliminieren oder reduzieren Oberflächenhotspots, verbessern die taktile Erfahrung der Verbraucher mit elektronischen Produkten. Können in Kombination mit anderen funktionalen Materialien verwendet werden (wie Verbund mit Graphit), um die Materialisolierleistung erheblich zu verbessern.'
      },
      electricHeating: {
        name: 'Elektrische Heizung',
        content: 'Verwendet leitfähige Beschichtungen zum Heizen. Geeignet für verschiedene Substrate einschließlich Metalle, Glas und Kunststoffe. Heizbeschichtungen werden im Allgemeinen durch Sprühen oder Siebdruck auf Zielsubstrate aufgetragen und erreichen Filmbildung und Aushärtung durch hohe Temperaturen. Leitfähige Heizbeschichtungen können auf Substrate verschiedener Formen aufgetragen werden, wobei Heizbereich und -form flexibel entsprechend den Anforderungen erreicht werden können.'
      },
      dielectric: {
        name: 'Dielektrikum',
        content: 'Hochtemperatur-Dielektrikbeschichtungen haben maximale langfristige Temperaturbeständigkeit von 300°C und können kurzzeitig tausende Grade Flammenverbrennung überstehen, während sie ausgezeichnete elektrische Isoliereigenschaften beibehalten. Geeignet für Elektrofahrzeuge, Stromversorgung, elektrische Heizung und viele andere Anwendungen, die elektrische Isolierung in Hochtemperaturumgebungen erfordern.'
      },
      electricConduction: {
        name: 'Elektrische Leitung',
        content: 'Graphenbasierte leitfähige Beschichtungen haben ausgezeichnete elektrische Leitfähigkeit und leitfähige Heizfunktionen; silberpulverbasierte leitfähige Silberpaste hat ausgezeichnete elektrische Leitfähigkeit. Unabhängig vom Typ der leitfähigen Beschichtung können sie langfristig bei 300°C arbeiten; zusätzlich überschreitet die Beschichtungsaushärtungstemperatur nicht 300°C.'
      }
    },

    // Produktdetail-Tabs
    tabs: {
      hpcm: 'Thermisches Phasenwechselmaterial-HPCM',
      hgp: 'Wärmeleitpad-HGP',
      hgpPt: 'Wärmeleit-Gelpad-HGP PT',
      hg: 'Einkomponenten-Wärmegel-HG',
      hf: 'Zweikomponenten-Wärmegel-HF',
      hgr: 'Wärmeleitpaste-HGR',
      hi: 'Wärmedämm-Isolierpad-HI',
      htb: 'Wärmeabsorbierendes Pad-HTB',
      hlm: 'Flüssigmetall-Pad-HLM',
      ahi: 'Aerogel-Wärmedämmfolie-AHI',
      ahiFoam: 'Aerogel-Schaum-AHI',
      nanoBoard: 'Nano-Platte'
    },

    // Gemeinsame Komponentenbeschriftungen
    common: {
      productFeatures: 'Produktmerkmale',
      typicalApplications: 'Typische Anwendungen',
      technicalParameters: 'Technische Parameter',
      testMethod: 'Testmethode',
      project: 'Element',
      color: 'Farbe',
      phaseChangeTemp: 'Phasenwechseltemperatur',
      density: 'Dichte',
      workingTemp: 'Arbeitstemperatur',
      volumeResistivity: 'Volumenwiderstand',
      thermalConductivity: 'Wärmeleitfähigkeit',
      thermalResistance: 'Wärmewiderstand',
      pressure: 'Druck',
      thickness: 'Dicke',
      hardness: 'Härte',
      tempRange: 'Temperaturbereich',
      dielectricConstant: 'Dielektrizitätskonstante',
      fireRating: 'Feuerwiderstandsklasse',
      component: 'Komponente',
      annotation: '*Zinkoxidfreie Version',
      thermalResistanceVsPressure: 'Wärmewiderstand vs. Druck',
      visualInspection: 'Sichtprüfung',
      gray: 'Grau'
    },

    // Produkt 1 - Thermisches Phasenwechselmaterial HPCM
    product1: {
      description: 'Das thermische Phasenwechselmaterial ist ein Grenzflächenmaterial, das mit einer speziellen Rezeptur und einem speziellen Verfahren hergestellt wird. Es bietet eine hohe Wärmeleitfähigkeit und kann bei einer bestimmten Temperatur die Phase wechseln, um die Benetzung der Grenzfläche zu verbessern. Unterhalb der Phasenwechseltemperatur ist das Material fest, was Verarbeitung und Nacharbeit erleichtert. Bei Erreichen der Phasenwechseltemperatur wird das Material weich und erzielt eine hervorragende Benetzung, wodurch der Grenzflächenwärmewiderstand stark reduziert und die Wärmeübertragung verbessert wird.',
      features: [
        'Wärmeleitfähigkeit von 2,5~10,0 W/m-K',
        'Extrem niedriger Wärmewiderstand',
        'Niedrige Phasenwechseltemperatur',
        'Einfaches Stanzen',
        'Hervorragende Zuverlässigkeit'
      ],
      applications: [
        'CPU & GPU & APU',
        'IGBT-Module',
        'Kommunikationsgeräte',
        'Computer',
        'Server / Rechenzentren'
      ]
    },

    // Produkt 3 - Wärmeleit-Gelpad HGP PT
    product3: {
      description: 'Wärmeleit-Gelpad ist ein elastisches Polymermaterial mit niedrigem Wärmewiderstand, das ausgezeichnete Wärmeleitfähigkeit und selbstklebende Eigenschaften aufweist, unregelmäßige Spalten effektiv füllt und effiziente Wärmeleitungspfade für die Wärmeableitung bietet.',
      features: [
        'Niedriger Grenzflächenwärmewiderstand',
        'Ausgezeichnete Oberflächenselbstklebung für einfache Installation',
        'Ultraniedrige Härte reduziert Installationsspannungsrückstände',
        'Hohes Kompressionsverhältnis erleichtert Spaltfüllung'
      ],
      applications: [
        'Flüssigkühlmodule/Server',
        'Kommunikationsbasisstations-Ausrüstung',
        'KI-Geräte',
        'CPU/GPU/APU',
        'Automobilelektronik'
      ],
      tableData: [
        {
          project: 'Komponente',
          test: '-',
          parameter1: 'Silikon',
          parameter2: 'Silikon',
          parameter3: 'Silikon'
        },
        {
          project: 'Farbe',
          test: 'Visuell',
          parameter1: 'Weiß',
          parameter2: 'Grau',
          parameter3: 'Grau'
        },
        {
          project: 'Wärmeleitfähigkeit｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '3.5',
          parameter2: '6.0',
          parameter3: '8.0'
        },
        {
          project: 'Dicke｜(mm)',
          test: '-',
          parameter1: '0.5~5.0',
          parameter2: '1.0~5.0',
          parameter3: '1.0~5.0'
        },
        {
          project: 'Dichte｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '3.2',
          parameter2: '3.3',
          parameter3: '3.4'
        },
        {
          project: 'Härte｜(shore 00)',
          test: 'ASTM D2240',
          parameter1: '10',
          parameter2: '10',
          parameter3: '10'
        },
        {
          project: 'Temperaturbereich｜(℃)',
          test: '-',
          parameter1: '-40~150',
          parameter2: '-40~150',
          parameter3: '-40~150'
        },
        {
          project: 'Dielektrizitätskonstante｜@1MHZ',
          test: 'ASTM D150',
          parameter1: '7.0',
          parameter2: '8.0',
          parameter3: '10.0'
        },
        {
          project: 'Volumenwiderstand｜(Ω-cm)',
          test: 'ASTM D257',
          parameter1: '10¹³',
          parameter2: '10¹³',
          parameter3: '10¹³'
        },
        {
          project: 'Feuerwiderstandsklasse',
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0'
        }
      ]
    },

    // Produkt 4 - Einkomponenten-Wärmegel HG
    product4: {
      description: 'Einkomponenten-Wärmegel ist eine Serie hochleistungsfähiger Wärmeschnittstellenmaterialien mit niedrigem Grenzflächenwärmewiderstand, hoher Plastizität, hoher elektrischer Isolierung und hoher Zuverlässigkeit. Es verfügt über Hochtemperatur-Ölabscheidungsbeständigkeit, Nicht-Trocknungs-, Nicht-Korrosions-Materialien, Hoch- und Tieftemperaturbeständigkeit und gute thixotrope Eigenschaften, geeignet für verschiedene Komponenten mit extrem niedrigen Spannungsanforderungen, wodurch hohe Zuverlässigkeit verschiedener Anwendungsprodukte gewährleistet wird.\n\nEs hat natürliche Klebeeigenschaften für bequeme Kundenmontage. Kunden können auch automatisierte Dosierung entsprechend ihren eigenen Prozessen implementieren, um die Produktionseffizienz zu verbessern.',
      features: [
        '2.0~9.0W/m-K Wärmeleitfähigkeit',
        'Ultra-niedrige Spannung: >40%@10psi',
        'Ausgezeichnete Benetzbarkeit, effektive Reduzierung des Grenzflächenwärmewiderstands',
        'Hohes Kompressionsverhältnis, geeignet für Chip-Wärmeübertragung bei verschiedenen Spalten'
      ],
      applications: [
        'Automobilelektronik',
        'Große Speichergeräte',
        'Verbraucherelektronikgeräte',
        'Kommunikationsbasisstations-Ausrüstung (4G und 5G)',
        'Stromversorgungsmodule'
      ],
      tableData: [
        {
          project: 'Komponente',
          test: '-',
          parameter1: 'Silikon',
          parameter2: 'Silikon',
          parameter3: 'Silikon',
          parameter4: 'Silikon',
          parameter5: 'Silikon'
        },
        {
          project: 'Farbe',
          test: 'Visuell',
          parameter1: 'Blau',
          parameter2: 'Grün',
          parameter3: 'Blau',
          parameter4: 'Grau',
          parameter5: 'Rosa'
        },
        {
          project: 'Wärmeleitfähigkeit｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '2.0',
          parameter2: '3.5',
          parameter3: '5.0',
          parameter4: '7.0',
          parameter5: '9.0'
        },
        {
          project: 'Dichte｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '2.0',
          parameter2: '3.2',
          parameter3: '3.2',
          parameter4: '3.4',
          parameter5: '3.5'
        },
        {
          project: 'Extrusionsgeschwindigkeit｜(g/min)',
          test: '30cc Standardrohr, 90psi Druck',
          parameter1: '40',
          parameter2: '35',
          parameter3: '35',
          parameter4: '15',
          parameter5: '10'
        },
        {
          project: 'Flüchtigkeit｜(%)',
          test: 'ASTM E595',
          parameter1: '<0.05',
          parameter2: '<0.05',
          parameter3: '<0.05',
          parameter4: '<0.03',
          parameter5: '<0.03'
        },
        {
          project: 'Temperaturbereich｜(℃)',
          test: '-',
          parameter1: '-40~150',
          parameter2: '-40~150',
          parameter3: '-40~150',
          parameter4: '-40~150',
          parameter5: '-40~150'
        },
        {
          project: 'Dielektrizitätskonstante｜@1MHZ',
          test: 'ASTM D150',
          parameter1: '5.0',
          parameter2: '8.0',
          parameter3: '7.5',
          parameter4: '8.0',
          parameter5: '8.0'
        },
        {
          project: 'Feuerwiderstandsklasse',
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0',
          parameter4: 'V-0',
          parameter5: 'V-0'
        }
      ]
    },

    // Produkt 5 - Zweikomponenten-Wärmegel HF  
    product5: {
      description: 'Zweikomponenten-Wärmegelmaterial wird durch Mischen von Komponente A (Base) und Komponente B (Härtungsmittel) in einem bestimmten Verhältnis gemischt und härtet bei Raumtemperatur zu einem flexiblen Elastomer aus, das ausgezeichnete Wärmeleitfähigkeit und elektrische Isoliereigenschaften aufweist. Das ausgehärtete Material behält gute Flexibilität und Elastizität bei, passt sich gut an verschiedene unregelmäßige Oberflächen an und bietet stabile Wärmeleitungspfade. Diese Serie kann verschiedene Wärmeleitfähigkeitsspezifikationen entsprechend unterschiedlichen Anwendungsanforderungen bereitstellen.',
      features: [
        '2.0~8.0W/m-K Wärmeleitfähigkeit',
        'Ausgezeichnete elektrische Isoliereigenschaften',
        'Behält Flexibilität und Elastizität nach dem Aushärten bei',
        'Ausgezeichnete Anpassungsfähigkeit, passt sich unregelmäßigen Oberflächen an',
        'Gute Langzeitstabilität'
      ],
      applications: [
        'Automobilelektronik ECU',
        'Ladestations-Module',
        'Kommunikationsbasisstations-Ausrüstung',
        'Energiespeicher-Batteriepacks',
        'LED-Beleuchtungs-Wärmeableitung'
      ],
      tableData: [
        {
          project: 'Komponente',
          test: '-',
          parameter1: 'Silikon',
          parameter2: 'Silikon',
          parameter3: 'Silikon',
          parameter4: 'Silikon',
          parameter5: 'Silikon',
          parameter6: 'Silikon'
        },
        {
          project: 'Farbe',
          test: 'Visuell',
          parameter1: 'Blau',
          parameter2: 'Blau',
          parameter3: 'Grün',
          parameter4: 'Blau',
          parameter5: 'Grau',
          parameter6: 'Grau'
        },
        {
          project: 'Wärmeleitfähigkeit｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '2.0',
          parameter2: '2.0',
          parameter3: '3.5',
          parameter4: '5.0',
          parameter5: '6.0',
          parameter6: '8.0'
        },
        {
          project: 'Dichte｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '2.2',
          parameter2: '2.0',
          parameter3: '3.2',
          parameter4: '3.2',
          parameter5: '3.3',
          parameter6: '3.4'
        },
        {
          project: 'Härte｜(Shore A)',
          test: 'ASTM D2240',
          parameter1: '15',
          parameter2: '10',
          parameter3: '25',
          parameter4: '35',
          parameter5: '40',
          parameter6: '45'
        },
        {
          project: 'Zugfestigkeit｜(MPa)',
          test: 'ASTM D412',
          parameter1: '0.8',
          parameter2: '0.6',
          parameter3: '1.2',
          parameter4: '1.5',
          parameter5: '1.8',
          parameter6: '2.0'
        },
        {
          project: 'Verarbeitungszeit｜(min)',
          test: '25℃',
          parameter1: '45',
          parameter2: '90',
          parameter3: '45',
          parameter4: '40',
          parameter5: '35',
          parameter6: '30'
        },
        {
          project: 'Aushärtezeit｜(h)',
          test: '25℃',
          parameter1: '24',
          parameter2: '24',
          parameter3: '24',
          parameter4: '24',
          parameter5: '24',
          parameter6: '24'
        },
        {
          project: 'Temperaturbereich｜(℃)',
          test: '-',
          parameter1: '-40~150',
          parameter2: '-40~150',
          parameter3: '-40~150',
          parameter4: '-40~150',
          parameter5: '-40~150',
          parameter6: '-40~150'
        },
        {
          project: 'Dielektrizitätskonstante｜@1MHZ',
          test: 'ASTM D150',
          parameter1: '5.0',
          parameter2: '4.5',
          parameter3: '8.0',
          parameter4: '7.5',
          parameter5: '8.0',
          parameter6: '8.5'
        },
        {
          project: 'Feuerwiderstandsklasse',
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0',
          parameter4: 'V-0',
          parameter5: 'V-0',
          parameter6: 'V-0'
        }
      ]
    },

    // Produkt 6 - Wärmeleitpaste HGR
    product6: {
      description: 'Wärmeleitpaste ist ein hochleistungsfähiges Wärmeschnittstellenmaterial mit ausgezeichneter Wärmeleitfähigkeit und elektrischen Isoliereigenschaften. Hergestellt mit organischem Silikonharz als Basismaterial und verschiedenen hochleitfähigen anorganischen Pulvern durch spezielle Verfahren. Bietet gute thixotrope Eigenschaften und Verarbeitbarkeit, füllt effektiv Mikrospalten zwischen wärmeerzeugenden Komponenten und Kühlkörpern, reduziert erheblich den Kontaktwärmewiderstand und verbessert die Wärmeableitungseffizienz.',
      features: [
        '2.0~6.0W/m-K Wärmeleitfähigkeit',
        'Ausgezeichnete thixotrope Eigenschaften, einfach aufzutragen',
        'Überlegene elektrische Isolierleistung',
        'Gute chemische Stabilität',
        'Niedrige Grenzflächendicke, effizienter Wärmetransfer'
      ],
      applications: [
        'CPU/GPU-Wärmeableitung',
        'Strommodule',
        'LED-Beleuchtung',
        'Automobilelektronik',
        'Kommunikationsgeräte'
      ],
      tableData: [
        {
          project: 'Komponente',
          test: '-',
          parameter1: 'Silikon',
          parameter2: 'Silikon',
          parameter3: 'Silikon',
          parameter4: 'Silikon'
        },
        {
          project: 'Farbe',
          test: 'Visuell',
          parameter1: 'Gelb',
          parameter2: 'Grau',
          parameter3: 'Grau',
          parameter4: 'Grau'
        },
        {
          project: 'Minimale Grenzflächendicke',
          test: '-',
          parameter1: '0.030',
          parameter2: '0.045',
          parameter3: '0.045',
          parameter4: '0.04'
        },
        {
          project: 'Dichte｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '3.1',
          parameter2: '2.9',
          parameter3: '2.9',
          parameter4: '2.9'
        },
        {
          project: 'Viskosität',
          test: 'ASTM D2196',
          parameter1: '<100,000',
          parameter2: '<400,000',
          parameter3: '<250,000',
          parameter4: '<250,000'
        },
        {
          project: 'Temperaturbereich｜(°C)',
          test: '-',
          parameter1: '-40~150',
          parameter2: '-40~150',
          parameter3: '-40~150',
          parameter4: '-40~150'
        },
        {
          project: 'Volumenwiderstand|(Ω.cm)',
          test: 'ASTM D257',
          parameter1: '10¹²',
          parameter2: '10¹¹',
          parameter3: '10¹¹',
          parameter4: '10¹¹'
        },
        {
          project: 'Feuerwiderstandsklasse',
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0',
          parameter4: 'V-0'
        },
        {
          project: 'Wärmeleitfähigkeit｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '2.0',
          parameter2: '3.5',
          parameter3: '5.0',
          parameter4: '6.0'
        }
      ],
      tableDataTwo: [
        {
          project: 'Druck｜(psi)',
          test: '-',
          parameter1: '50/100',
          parameter2: '50/100',
          parameter3: '50/100',
          parameter4: '50/100'
        },
        {
          project: 'Wärmewiderstand｜(℃-cm²/W)',
          test: 'ASTM D5470',
          parameter1: '0.13/0.11',
          parameter2: '0.06/0.05',
          parameter3: '0.05/0.04',
          parameter4: '0.045/0.038'
        }
      ]
    },

    product7: {
      description: 'Wärmedämm-Isolierpads sind eine Serie von Hochleistungs-Wärmeschnittstellenmaterialien, die mit Glasfasergewebe und anderen Materialien verstärkt sind. Sie zeichnen sich durch ausgezeichnete Schnittfestigkeit und überlegene Wärmeleitfähigkeit aus und werden weit verbreitet in der Elektronik- und Elektroindustrie eingesetzt. Bei der Verwendung wählen Sie verschiedene Dicken von Wärmeleit-Silikonpads zum Schneiden entsprechend der Größe und Spaltenhöhe der Wärmeschnittstelle aus und platzieren sie in den Spalten zwischen Wärmeschnittstellen und ihren Komponenten als wärmeleitende Medien.',
      features: [
        'Bis zu 3.5W/m-K Wärmeleitfähigkeit',
        'Durchschlagspannung >6,000Vac',
        'Flexibles Flachmaterial, leicht zu formen, kann nach Kundenanforderungen geschnitten werden',
        'Feuchtigkeitsbeständig, ausgezeichnete Witterungsbeständigkeit, hohe Zuverlässigkeit, leicht zu entfernen',
        'Einseitige Klebprodukte verfügbar (A1)'
      ],
      applications: [
        'OBC Bordladegeräte',
        'Leistungsverstärker',
        'Stromversorgungen',
        'Automobilelektronik',
        'Leistungshalbleiter'
      ],
      pressureLabel: 'Druck (psi)',
      thermalResistanceLabel: 'Wärmewiderstand (℃-cm²/W)',
      tableData: [
        {
          project: 'Komponente',
          test: '-',
          parameter1: 'Silikon+Glasfaser',
          parameter2: 'Silikon+Glasfaser',
          parameter3: 'Silikon+Glasfaser',
          parameter4: 'Silikon+PI'
        },
        {
          project: 'Farbe',
          test: 'Visuell',
          parameter1: 'Braunrot',
          parameter2: 'Schwarz',
          parameter3: 'Weiß',
          parameter4: 'Gelb'
        },
        {
          project: 'Dicke｜(mm)',
          test: 'ASTM D374',
          parameter1: '0.23',
          parameter2: '0.23',
          parameter3: '0.25/0.38/0.5',
          parameter4: '0.15'
        },
        {
          project: 'Dichte｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '2.5',
          parameter2: '2.7',
          parameter3: '1.5',
          parameter4: '2.5'
        },
        {
          project: 'Härte｜(shore A)',
          test: 'ASTM D2240',
          parameter1: '92',
          parameter2: '80',
          parameter3: '70',
          parameter4: '90'
        },
        {
          project: 'Zugfestigkeit｜(MPa)',
          test: 'ASTM D412',
          parameter1: '9.0',
          parameter2: '9.0',
          parameter3: '15',
          parameter4: '20'
        },
        {
          project: 'Temperaturbereich｜(°C)',
          test: '-',
          parameter1: '-60~200',
          parameter2: '-60~200',
          parameter3: '-60~200',
          parameter4: '-60~180'
        },
        {
          project: 'Durchschlagspannung｜(Kv)',
          test: 'ASTM D149',
          parameter1: '>5.5',
          parameter2: '>6.0',
          parameter3: '>4.0',
          parameter4: '>6.0'
        },
        {
          project: 'Feuerwiderstandsklasse',
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0',
          parameter4: 'V-0'
        },
        {
          project: 'Wärmeleitfähigkeit｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '1.6',
          parameter2: '1.8',
          parameter3: '3.5',
          parameter4: '1.3'
        }
      ],
      tableDataTwo: [
        {
          project: 'Druck｜(psi)',
          test: '-',
          parameter1: '50',
          parameter2: '0.61',
          parameter3: '0.53',
          parameter4: '0.27',
          parameter5: '0.41'
        },
        {
          project: 'Wärmewiderstand｜(℃-cm²/W)',
          test: 'ASTM D5470',
          parameter1: '100',
          parameter2: '0.47',
          parameter3: '0.47',
          parameter4: '0.25',
          parameter5: '0.38'
        }
      ]
    },

    // Produkt 8 - Wärmeabsorbierendes Pad HTB
    product8: {
      description: 'Wärmeabsorbierendes Pad ist eine Serie von Wärmeschnittstellenmaterialien mit hoher Wärmeleistung und bestimmter EMI-Leistung, die jetzt weit verbreitet in optischen Modulen, Kommunikationsbasisstationen usw. verwendet werden. Wählen Sie bei der Verwendung verschiedene Dicken von Wärmeleit-Silikonpads zum Schneiden entsprechend der Größe und Spaltenhöhe der Wärmeschnittstelle aus und platzieren Sie sie in den Spalten zwischen Wärmeschnittstellen und ihren Komponenten, um eine gute Wärmeübertragungsfunktion zu erreichen und gleichzeitig bestimmte elektromagnetische Störungen zu eliminieren, um einen stabilen Betrieb der Komponenten zu gewährleisten.',
      features: [
        'Ähnlich wie traditionelle Wärmeleitpads, mit selbstklebender Oberfläche für einfache Anwendung',
        'Extrem niedriger Wärmewiderstand kombiniert mit EMI-Abschirmeffekt',
        'Hohe Zuverlässigkeit',
        'Kann Metallschilde teilweise ersetzen, reduziert Kosten und ist einfach zu bedienen'
      ],
      applications: [
        'Gehäuse oder zugehörige Wärmeableitungsmodule',
        'Smart-Terminals',
        'Kommunikationsausrüstung',
        'Unterhaltungselektronik'
      ],
      tableData: [
        {
          project: 'Farbe',
          test: 'Visuell',
          parameter1: 'Schwarz',
          parameter2: 'Schwarz',
          parameter3: 'Schwarz'
        },
        {
          project: 'Dicke｜(mm)',
          test: 'ASTM D374',
          parameter1: '0.5-5.0',
          parameter2: '0.5-5.0',
          parameter3: '0.5-5.0'
        },
        {
          project: 'Wärmeleitfähigkeit｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '1.4',
          parameter2: '3',
          parameter3: '6.0'
        },
        {
          project: 'Dichte｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '4.0',
          parameter2: '3.5',
          parameter3: '4.5'
        },
        {
          project: 'Härte｜(shore 00)',
          test: 'ASTM D2240',
          parameter1: '92',
          parameter2: '80',
          parameter3: '70'
        },
        {
          project: 'Volumenwiderstand｜(Ω.cm)',
          test: 'ASTM D257',
          parameter1: '10¹²',
          parameter2: '10¹²',
          parameter3: '‌10⁸‌'
        },
        {
          project: 'EMI-Dämpfung',
          test: '(dB/cm)@2 GHz｜(dB/cm) @ 5 GHz',
          parameter1: '8｜15',
          parameter2: '10｜20',
          parameter3: '10｜20'
        },
        {
          project: 'Betriebstemperatur｜(°C)',
          test: '/',
          parameter1: '-40~180',
          parameter2: '-40~180',
          parameter3: '-40~180'
        },
        {
          project: 'Feuerwiderstandsklasse',
          test: 'UL94',
          parameter1: 'V-0',
          parameter2: 'V-0',
          parameter3: 'V-0'
        }
      ]
    },

    // Produkt 9 - Flüssigmetall-Pad HLM
    product9: {
      description: 'Flüssigmetall-Pad ist eine Serie von Hochleistungs-Schnittstellenmaterialien, die zwischen Heizgeräten und Kühlkörpern verwendet werden. Nach Erreichen der Phasenwechseltemperatur des Flüssigmetalls erweicht das Material automatisch, um die Lücken zwischen Heizgeräten und Kühlkörpern zu füllen. Es hat einen sehr niedrigen Grenzflächenwärmewiderstand und kann die von Heizgeräten erzeugte Wärme schnell auf die kalte Seite übertragen, die Temperatur der Heizgeräte effizient senken und die Leistung elektronischer Komponenten gewährleisten.',
      features: [
        'Ultrahoch Wärmeleitfähigkeit (20~50W/m-k)',
        'Hohe Produktzuverlässigkeit',
        'Kein Pump-out',
        'Keine organische Verflüchtigung',
        'Umweltfreundlich'
      ],
      applications: [
        'Server',
        'Spielkonsolen',
        'GPU/CPU/APU',
        'Kommunikationsausrüstung',
        'Automobilelektronik'
      ],
      tableData: [
        {
          project: 'Basismaterial',
          test: '-',
          parameter1: 'Bismut-Legierung',
          parameter2: 'Bismut-Legierung',
          parameter3: 'Bismut-Legierung'
        },
        {
          project: 'Farbe',
          test: 'Visuell',
          parameter1: 'Hellsilber',
          parameter2: 'Hellsilber',
          parameter3: 'Hellsilber'
        },
        {
          project: 'Dicke｜(mm)',
          test: 'ASTM D374',
          parameter1: '0.07~0.30',
          parameter2: '0.07~0.30',
          parameter3: '0.07~0.30'
        },
        {
          project: 'Phasenwechselpunkt｜(°C)',
          test: 'ASTM B774',
          parameter1: '72',
          parameter2: '118',
          parameter3: '60/119'
        },
        {
          project: 'Härte｜(HB)',
          test: 'ASTME10',
          parameter1: '4.5',
          parameter2: '4.5',
          parameter3: '7.5'
        },
        {
          project: 'Dichte｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '8.0',
          parameter2: '7.2',
          parameter3: '7.5'
        },
        {
          project: 'Betriebstemperatur｜(°C)',
          test: '-',
          parameter1: '-50~500',
          parameter2: '-50~500',
          parameter3: '-50~500'
        },
        {
          project: 'Volumenwiderstand｜(Ω.m)',
          test: 'ASTM D257',
          parameter1: '10⁻⁸',
          parameter2: '10⁻⁸',
          parameter3: '10⁻⁸'
        },
        {
          project: 'Wärmeleitfähigkeit｜(W/m-K)',
          test: 'ASTM E1461',
          parameter1: '30',
          parameter2: '43',
          parameter3: '30'
        }
      ]
    },

    // Produkt 10 - Aerogel-Wärmedämmfolie AHI
    product10: {
      description: 'Aerogel-Wärmedämmfolie ist eine Serie von Dämmfolien, die aus Nano-Aerogel bestehen. Durch spezielle Prozesse wird Nano-Aerogel zu dünnen Filmen geformt, die hervorragende Dämmleistung bieten, um Hotspot-Probleme in begrenzten Räumen von Unterhaltungselektronikprodukten zu lösen, Dämmschutz für schwach hitzebeständige Komponenten zu bieten, die Richtung der Wärmeleitung zu kontrollieren und zu ändern sowie Produktlebensdauer und -leistung zu verbessern. Nano-Aerogel-Dämmfolie blockiert die Richtung der Wärmeübertragung durch Aerogel-Nanolücken, wodurch die Produktoberflächentemperatur gesenkt, Hotspots auf Produktoberflächen reduziert oder beseitigt und die taktile Erfahrung der Verbraucher mit elektronischen Produkten verbessert wird.\n\nAerogel-Dämmfolie kann als einseitig klebendes Material hergestellt werden, um die Kundeninstallation zu erleichtern, und kann in Kombination mit anderen funktionalen Materialien verwendet werden (wie Verbund mit Graphit), um die Dämmleistung des Materials erheblich zu verbessern.',
      features: [
        '0.018~0.023W/m-k niedrige Wärmeleitfähigkeit',
        'Dickenbereich 0.05-0.4mm',
        'Ausgezeichnete elektrische Isolierung und einfach zu stanzen',
        'Kann mit anderen Materialien laminiert werden'
      ],
      applications: [
        'E-Zigaretten',
        'Smartphones',
        'Tablets/Laptops',
        'Smartwatches'
      ],
      tableData: [
        {
          project: 'Material',
          test: '-',
          parameter1: 'Aerogel',
          parameter2: 'Aerogel',
          parameter3: 'Aerogel',
          parameter4: 'Aerogel',
          parameter5: 'Aerogel'
        },
        {
          project: 'Farbe',
          test: 'Visuell',
          parameter1: 'Weiß',
          parameter2: 'Weiß',
          parameter3: 'Weiß',
          parameter4: 'Hellsilber',
          parameter5: 'Hellsilber'
        },
        {
          project: 'Wärmeleitfähigkeit｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '0.018～0.023',
          parameter2: '0.018～0.023',
          parameter3: '0.018～0.023',
          parameter4: '0.018～0.023',
          parameter5: '0.018～0.023'
        },
        {
          project: 'Dicke｜(mm)',
          test: '-',
          parameter1: '0.05',
          parameter2: '0.10',
          parameter3: '0.20',
          parameter4: '0.30',
          parameter5: '0.40'
        },
        {
          project: 'Dichte｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '0.3',
          parameter2: '0.3',
          parameter3: '0.3',
          parameter4: '0.3',
          parameter5: '0.3'
        },
        {
          project: 'Arbeitstemperatur｜(℃)',
          test: '-',
          parameter1: '-40～130',
          parameter2: '-40～130',
          parameter3: '-40～130',
          parameter4: '-40～130',
          parameter5: '-40～130'
        },
        {
          project: 'Durchschlagfestigkeit｜(Kv/mm)',
          test: 'ASTM D149',
          parameter1: '>4.0',
          parameter2: '>4.0',
          parameter3: '>4.0',
          parameter4: '>4.0',
          parameter5: '>4.0'
        },
        {
          project: 'Volumenwiderstand｜(Ω-cm)',
          test: 'ASTM D257',
          parameter1: '10¹³',
          parameter2: '10¹³',
          parameter3: '10¹³',
          parameter4: '10¹³',
          parameter5: '10¹³'
        }
      ]
    },

    // Produkt 11 - Aerogel-Schaum AHI
    product11: {
      description: 'Aerogel-Schaum ist eine Serie von Dämmschäumen aus Nano-Aerogel. Durch spezielle superkritische Prozesse wird eine netzartige poröse Nano-Aerogel-Struktur gebildet, die hervorragende Dämmfähigkeit bietet und Dämmschutz für schwach hitzebeständige Komponenten bietet. Das Material hat auch eine hohe Kompressibilität, die ein besseres Füllen unregelmäßiger Räume für verbesserte Dämmeffekte ermöglicht und die Produktlebensdauer und Benutzererfahrung verbessert.\n\nAerogel-Dämmschaum kann als einseitig klebendes Material hergestellt werden, um die Kundeninstallation zu erleichtern, und kann auch in Kombination mit anderen funktionalen Materialien verwendet werden (wie Graphit-Verbund), um Verbundleistung zu bieten.',
      features: [
        '0.018w/m-k ultraniedrige Wärmeleitfähigkeit',
        'Dicke 0.5-3.0mm',
        'Ausgezeichnete Kompressionsleistung',
        'Ausgezeichnete elektrische Isolierung',
        'Einfach zu stanzen'
      ],
      applications: [
        'E-Zigaretten',
        'Smartphones',
        'Tablets/Laptops',
        'Smartwatches'
      ],
      tableData: [
        {
          project: 'Material',
          test: '-',
          parameter1: 'Aerogel',
          parameter2: 'Aerogel',
          parameter3: 'Aerogel',
          parameter4: 'Aerogel'
        },
        {
          project: 'Farbe',
          test: 'Visuell',
          parameter1: 'Weiß',
          parameter2: 'Weiß',
          parameter3: 'Weiß',
          parameter4: 'Hellsilber'
        },
        {
          project: 'Wärmeleitfähigkeit｜(W/m-K)',
          test: 'ASTM D5470',
          parameter1: '0.018',
          parameter2: '0.07~0.30',
          parameter3: '0.018',
          parameter4: '0.018'
        },
        {
          project: 'Dicke｜(mm)',
          test: '-',
          parameter1: '0.5',
          parameter2: '1.0',
          parameter3: '2.0',
          parameter4: '3.0'
        },
        {
          project: 'Dichte｜(g/cm³)',
          test: 'ASTM D792',
          parameter1: '-0.1',
          parameter2: '-0.1',
          parameter3: '-0.1',
          parameter4: '-0.1'
        },
        {
          project: 'Arbeitstemperatur｜(°C)',
          test: '-',
          parameter1: '-60~240',
          parameter2: '-60~240',
          parameter3: '-60~240',
          parameter4: '-60~240'
        },
        {
          project: 'Durchschlagfestigkeit｜(Kv/mm)',
          test: 'ASTM D149',
          parameter1: '>3.0',
          parameter2: '>3.0',
          parameter3: '>3.0',
          parameter4: '>3.0'
        },
        {
          project: 'Volumenwiderstand｜(Ω-cm)',
          test: 'ASTM D257',
          parameter1: '10¹³',
          parameter2: '10¹³',
          parameter3: '10¹³',
          parameter4: '10¹³'
        }
      ]
    },

    // Produkt 12 - Nano-Platte
    product12: {
      description: 'Nano-Platte ist ein Hochleistungs-Wärmedämmmaterial. Basierend auf eingehender Materialforschung wurde eine effektive Blockierung von Wärmeübertragungspfaden (Wärmeleitung, Wärmekonvektion, Wärmestrahlung) entwickelt, um effektive und hervorragende Wärmedämmeffekte zu erzielen. Das Produkt basiert auf Aerogel und anderen Nanomaterialien, ergänzt durch Hochtemperaturverstärkung und Hochtemperatur-Dämmkomponenten, verarbeitet mit speziellen Formgebungstechniken.\nNano-Plattenmaterial hat bei niedrigen Temperaturen eine geringere Wärmeleitfähigkeit als Luft und bei hohen Temperaturen eine niedrigere Wärmeleitfähigkeit als Aerogel, bei gleichzeitig extrem hoher thermischer Stabilität und überlegener Thermoschockbeständigkeit. Die Dämmleistung von Aerogel-Weltraumplatten ist mehrfach höher als die von traditionellen Materialien und macht sie zum idealsten Hochtemperatur-Dämmmaterial auf dem Markt.',
      productFeaturesTitle: 'Produktmerkmale',
      productFeaturesIntro: 'Die Wärmeleitfähigkeit λ des Materials wird durch drei thermische Eigenschaften des Materials charakterisiert:<br>λgesamt = λLeitung + λKonvektion + λStrahlung',
      productFeatures: [
        'In Aerogel und anderen Nanomaterialien können nanostrukturierte Strukturen extrem kleine Kontaktpunkte haben, und Nanostrukturen verlängern auch den Wärmeübertragungsweg erheblich, wodurch die λLeitung des Materials reduziert wird.',
        'In Aerogel und anderen Nanomaterialien können nanostrukturierte Strukturen eine effektive Porosität (bis zu 90%) bilden, und feine Nanostrukturen eliminieren auch effektiv die Luftkonvektion (mittlere freie Weglänge von Gasmolekülen beträgt 70-120 nm), wodurch die Wärmeübertragung λKonvektion reduziert wird.',
        'Durch Hinzufügen von Wärmedämmkomponenten zur Materialstruktur kann die Wärmestrahlungsfähigkeit des Materials reduziert werden, wodurch λStrahlung minimiert wird.'
      ],
      productFeaturesTip: 'Dadurch wird die Gesamtwärmeleitfähigkeit λgesamt des Materials reduziert',
      productDetailTitle: 'Produktdetails',
      productDetailItems: [
        'Nano-Platte behält bei hohen Temperaturen eine extrem niedrige Wärmeleitfähigkeit bei, mit offensichtlicher Wirkung auf Hochtemperatur-Wärmedämmung. Testberichte Dritter zeigen eine Wärmeleitfähigkeit von nur 0,036 W/m-k bei 800°C, deutlich besser als superkritisches Aerogel.',
        'Im Vergleich zu superkritisch getrocknetem Aerogel-Filz auf dem Markt hat Nano-Platte offensichtliche Vorteile bei der Dämmleistung (Heizplattenmethode).',
        '',
        'Nano-Platte hat eine gewisse Kompressionsleistung, die sicherstellt, dass sie bei Verwendung zwischen Zellen eine gewisse Zellenausdehnung absorbieren kann, um die mechanische Leistung der Zellen zu gewährleisten. Kann nach Kundenanforderungen angepasst werden.'
      ],
      agingTips: 'Alterungstest, 85°C&85%RH Alterung 1000 Stunden, 125°C Hochtemperaturalterung 1000 Stunden, die Wärmeleitfähigkeit, Dämmleistung und Spannungsfestigkeitstest der Nano-Platte haben grundsätzlich keine Änderung, die Kompressionsleistung hat leichte Änderungen, wie folgt:',
      bottomTips: '*Alle oben genannten Materialien wurden mit PET-Duroplastfolie getestet',
      tableHeaders: {
        unit: 'Einheit',
        testStandard: 'Teststandard',
        agingCondition: 'Alterungsbedingung',
        testTemperature: 'Testtemperatur ℃',
        thermalConductivity: 'Wärmeleitfähigkeit W/(m-K)',
        insulationTest: 'Dämmtest - Temperaturdifferenz',
        coldSideTemp: 'Dämmtest - Kaltseitentemperatur',
        voltageTest: 'Spannungsfestigkeitstest (3000V/60S)',
        compressionTest: 'Kompressionstest',
        strain: 'Dehnung (%)',
        pressure: 'Druck'
      },
      tableData: [
        {
          project: 'Betriebstemperatur｜Operation Temperature',
          test: '°C',
          parameter1: '700',
          parameter2: '950',
          parameter3: '1100',
          parameter4: '1200',
          parameter5: '-'
        },
        {
          project: 'Farbe｜Color',
          test: '-',
          parameter1: 'Grau/Weiß',
          parameter2: 'Grau/Weiß',
          parameter3: 'Grau/Weiß',
          parameter4: 'Grau/Weiß',
          parameter5: 'Visual'
        },
        {
          project: 'Dicke｜Thickness',
          test: 'mm',
          parameter1: '1.0~5mm',
          parameter2: '1.0~5mm',
          parameter3: '1.0~5mm',
          parameter4: '1.0~5mm',
          parameter5: '-'
        },
        {
          project: 'Dichte｜Density',
          test: 'kg/m3',
          parameter1: '300',
          parameter2: '300',
          parameter3: '300',
          parameter4: '300',
          parameter5: 'GB/T 17911'
        },
        {
          project: 'Zugfestigkeit｜Tensile Strength',
          test: 'MPa',
          parameter1: '0.15',
          parameter2: '0.15',
          parameter3: '0.15',
          parameter4: '0.15',
          parameter5: 'GB/T 17911'
        },
        {
          project: 'Druckspannung｜Compression Stress',
          test: '-',
          parameter1: '15%(1MPa)｜25%(2MPa)',
          parameter2: '15%(1MPa)｜25%(2MPa)',
          parameter3: '15%(1MPa)｜25%(2MPa)',
          parameter4: '15%(1MPa)｜25%(2MPa)',
          parameter5: 'Internal'
        },
        {
          project: 'Durchschlagfestigkeit｜Electrical Strength',
          test: 'kv/mm',
          parameter1: '2.0',
          parameter2: '2.1',
          parameter3: '2.1',
          parameter4: '2.0',
          parameter5: 'GB/T 1408'
        },
        {
          project: 'Oberflächenwiderstand｜Surface Resistance',
          test: 'Ohms',
          parameter1: '>1×10⁹',
          parameter2: '>1×10⁹',
          parameter3: '>1×10⁹',
          parameter4: '>1×10⁹',
          parameter5: 'GB/T 1410'
        },
        {
          project: 'Spannungsfestigkeitstest｜Hi-pot test',
          test: '3000V｜DC/60S',
          parameter1: 'Pass',
          parameter2: 'Pass',
          parameter3: 'Pass',
          parameter4: 'Pass',
          parameter5: 'IEC 60950'
        },
        {
          project: 'Wärmekapazität｜Heat Capacity',
          test: 'J/g·℃',
          parameter1: '1.09',
          parameter2: '1.1',
          parameter3: '1.13',
          parameter4: '1.15',
          parameter5: 'ISO 11357-4'
        },
        {
          project: 'Wärmeleitfähigkeit｜Thermal Conductivity',
          test: 'W/m-k｜25℃｜200℃｜400℃｜600℃｜800℃',
          parameter1: '-｜0.021｜0.024｜0.026｜0.030｜0.038',
          parameter2: '-｜0.020｜0.022｜0.026｜0.030｜0.036',
          parameter3: '-｜0.019｜0.021｜0.023｜0.026｜0.036',
          parameter4: '-｜0.021｜0.023｜0.026｜0.029｜0.037',
          parameter5: 'GB/T10294'
        },
        {
          project: 'Entflammbarkeit｜Flammability',
          test: '-',
          parameter1: 'v-0',
          parameter2: 'v-0',
          parameter3: 'v-0',
          parameter4: 'v-0',
          parameter5: 'UL94'
        },
        {
          project: 'EHS-Konformität｜EHS Compliance',
          test: '-',
          parameter1: 'Konform',
          parameter2: 'Konform',
          parameter3: 'Konform',
          parameter4: 'Konform',
          parameter5: '/'
        }
      ],
      tableDataChart: [
        {
          project: 'Druck (Mpa)',
          test: '0.50',
          parameter1: '1.00',
          parameter2: '1.50',
          parameter3: '2.00',
          parameter4: '2.50'
        }
      ],
      tableData2: [
        {
          project: 'Vor Alterung',
          test: '25',
          parameter1: '0.0253'
        },
        {
          project: '125℃ 500hrs',
          test: '25',
          parameter1: '0.0272'
        },
        {
          project: '125℃ 1000hrs',
          test: '25',
          parameter1: '0.0243'
        },
        {
          project: '85℃&85%RH 500hrs',
          test: '25',
          parameter1: '0.0253'
        },
        {
          project: '85℃&85%RH 1000hrs',
          test: '25',
          parameter1: '0.0260'
        }
      ],
      tableData3: [
        {
          project: 'Vor Alterung',
          test: '85℃&85%RH (500hrs)',
          parameter1: '85℃&85%RH (1000hrs)',
          parameter2: '125℃ (500hrs)',
          parameter3: '125℃ (1000hrs)'
        },
        {
          project: '504.775',
          test: '500',
          parameter1: '503.9',
          parameter2: '505.3',
          parameter3: '503.6'
        }
      ],
      tableData4: [
        {
          project: 'Vor Alterung',
          test: '85℃&85%RH (500hrs)',
          parameter1: '85℃&85%RH (1000hrs)',
          parameter2: '125℃ (500hrs)',
          parameter3: '125℃ (1000hrs)'
        },
        {
          project: '160.5',
          test: '165.3',
          parameter1: '158.3',
          parameter2: '164.7',
          parameter3: '164.5'
        }
      ],
      tableData5: [
        {
          project: 'Vor Alterung',
          test: '85℃&85%RH (500hrs)',
          parameter1: '85℃&85%RH (1000hrs)',
          parameter2: '125℃ (500hrs)',
          parameter3: '125℃ (1000hrs)'
        },
        {
          project: 'Mit Folie',
          test: 'Mit Folie',
          parameter1: 'Mit Folie',
          parameter2: 'Mit Folie',
          parameter3: 'Mit Folie'
        },
        {
          project: 'Pass',
          test: 'Pass',
          parameter1: 'Pass',
          parameter2: 'Pass',
          parameter3: 'Pass'
        }
      ],
      tableData6: [
        {
          project: 'Druck',
          test: 'Vor Alterung',
          parameter1: '85℃&85%RH (1000hrs)',
          parameter2: '125℃ (1000hrs)'
        },
        {
          project: '1MPa',
          test: '21.7%',
          parameter1: '18.0%',
          parameter2: '19.2%'
        },
        {
          project: '1.5MPa',
          test: '29.1%',
          parameter1: '24.0%',
          parameter2: '25.5%'
        },
        {
          project: '2MPa',
          test: '34.8%',
          parameter1: '28.5%',
          parameter2: '30.0%'
        }
      ]
    }

  },

  // Service & Support
  serviceSupport: {
    bannerTitle: 'Service & Support',
    title: 'Service & Support',
    learnMore: 'Mehr erfahren',
    list: {
      productInfo: 'Produktgrundwissen',
      development: 'Produktentwicklungsunterstützung',
      application: 'Anwendungsunterstützung',
      simulation: 'Simulationsunterstützung',
    },
    // Produktinfo-Seite
    productInfoPage: {
      pageTitle: 'Produktgrundwissen',
      breadcrumbService: 'Service & Support',
      breadcrumbProductInfo: 'Produktgrundwissen',
      tabList: [
        { name: 'Nano-Isolierplatten-Einführung', id: 1 },
        { name: 'Aerogel-Einführung', id: 2 },
        { name: 'Wärmeleit-Schnittstellenmaterial (TIM) Einführung', id: 3 },
        { name: 'Wärmedämmmaterial-Einführung', id: 4 }
      ]
    },
    // Produktentwicklungsunterstützung-Seite
    developmentPage: {
      pageTitle: 'Produktentwicklungsunterstützung',
      breadcrumbService: 'Service & Support',
      breadcrumbDevelopment: 'Produktentwicklungsunterstützung',
      contentTitle: 'Produktentwicklungsunterstützung',
      contentText: 'Mit Fokus auf den Innovationskern der Frontend-Entwicklung bieten wir präzise Lösungen für neue Kundenanforderungen und Anwendungsprobleme neuer Materialien durch vollständige, maßgeschneiderte F&E-Kollaborationsdienste. Von der Anforderungsanalyse über Markttrend-Bewertung und Materialauswahl bis hin zur Formeloptimierung, Strukturdesign, schnellen Prototypenerstellung und Leistungsvalidierung – unser professionelles F&E-Team bietet durchgängige technische Unterstützung, überwindet technische Barrieren, beschleunigt die Markteinführung neuer Produkte und optimiert gleichzeitig Produktleistung, reduziert F&E-Kosten und steigert Kernwettbewerbsfähigkeit sowie Marktiterationseffizienz für eine Win-Win-Situation bei technischer Innovation und Produktupgrade.'
    },
    // Simulationsunterstützung-Seite
    simulationPage: {
      pageTitle: 'Simulationsunterstützung',
      breadcrumbService: 'Service & Support',
      breadcrumbSimulation: 'Simulationsunterstützung',
      contentTitle: 'Simulationsunterstützung',
      contentText: 'Ausgestattet mit professionellen Simulationstechnik-Teams und fortschrittlichen Simulationstools bieten wir umfassende Produktsimulationsunterstützung zur proaktiven Risikominimierung in F&E und Anwendung. Wir führen mehrdimensionale Simulationsmodellierung durch, einschließlich thermischer, mechanischer und strömungsdynamischer Analysen für verschiedene Produktanwendungsszenarien, um Betriebszustand, Leistung und potenzielle Probleme unter realen Arbeitsbedingungen präzise zu reproduzieren. Durch Simulationsanalyse optimieren wir Produktstrukturdesign, Materialauswahl und Prozessparameter, reduzieren erheblich physische Versuchs- und Fehlerkosten, verkürzen F&E-Zyklen und gewährleisten gleichzeitig, dass Produkte Industriestandards in Festigkeit, Stabilität und Sicherheit erfüllen – für eine solide technische Garantie bei Massenproduktion und Markteinführung.'
    },
    // Anwendungsunterstützung-Seite
    applicationPage: {
      pageTitle: 'Anwendungsunterstützung',
      breadcrumbService: 'Service & Support',
      breadcrumbApplication: 'Anwendungsunterstützung',
      contentTitle: 'Anwendungsunterstützung',
      contentText: 'Basierend auf umfangreicher Branchenerfahrung bieten wir ganzheitliche Anwendungslösungen für alle Szenarien und decken maßgeschneiderte Produktlieferungen in verschiedenen Formaten ab, um individuelle Anforderungen verschiedener Branchen und Arbeitsbedingungen zu erfüllen. Die Produktformate umfassen große Platten, präzise gestanzte Teile, Sonderformteile, maßgeschneiderte Baugruppen usw. Wir können Verarbeitungstechniken entsprechend spezifischen Kundenanwendungsszenarien optimieren, um Produktkompatibilität sicherzustellen. Darüber hinaus bieten wir professionelle Installationsanleitung, Vor-Ort-Technikkommissionierung, Prozessoptimierungsempfehlungen und Wartungsberatung nach der Nutzung, vereinfachen Kundenproduktimplementierungsprozesse, lösen verschiedene technische Herausforderungen während der Anwendung und gewährleisten stabilen Produktbetrieb.'
    },
    // Produktkomponenten-Seiten
    servicesProduct1: {
      title: 'Nano-Isolierplatten-Einführung',
      definition: 'Definition',
      definitionContent: 'Nano-Isolierplatten sind neue anorganische Plattenmaterialien basierend auf Nanomikroporen-Wärmeisolierungsprinzipien, hergestellt aus nanoskaligem Titansilikat und SiO₂ durch spezielle Verfahren zur Bildung submikroner Porenstrukturen. Ihre Wärmeleitfähigkeit ist niedriger als ruhende Luft, mit Isolierungseffekten 3-10 Mal höher als herkömmliche Materialien. Sie können stabil bei 400-1200℃ arbeiten, Isolierschichtdicke reduzieren, Energieverbrauch senken, Raum erweitern und sich an mehrere Szenarien anpassen.',
      productIntro: 'Produkteinführung',
      productIntroContent: 'Interne Mikroporendurchmesser sind viel kleiner als die mittleren freien Weglängen von Luftmolekülen und blockieren Wärmeleitung und -konvektion. Anorganische Nanopartikel unterdrücken Wärmestrahlung und bilden eine "dreifache Isolationsbarriere". 100% anorganische Zusammensetzung, keine schädlichen Substanzen, umweltsicher. Verarbeitet durch Rohstoffdispersion, Kompressionsmoldung und kundenspezifische Verarbeitungsschritte.',
      performanceAdvantage: 'Leistungsvorteile',
      mainProductSystem: 'Hauptproduktsystem',
      applicationValue: 'Anwendungswert',
      applicationValueContent: 'Mit "Materialinnovation ersetzt Raumverbrauch", Antrieb industrieller Geräte zur aktiven Verbrauchsreduzierung, Durchbruch traditioneller Materialschutzgrenzen, Unterstützung der Produktminiaturisierung und Kernwahl für kohlenstoffarme und Sicherheitsupgrades.',
      advantages: [
        {
          title: 'Ultimative Isolierung',
          content: ['Wärmeleitfähigkeit bis zu 0,02W/m-k bei Raumtemperatur;', '0,040W/m-k bei 800℃;', 'Energieeinsparung 10-30%;', 'Isolierschichtdicke um 50% oder mehr reduziert.']
        },
        {
          title: 'Umweltanpassung',
          content: ['Langzeitverwendung bei 400-1200℃;', 'Linearschwund ≤2% bei 1050℃;', 'Verfügbar in starren Platten, flexiblen Folienformen;', 'Einige Produkte sind hydrophob, Klasse A feuerfest.']
        },
        {
          title: 'Wirtschaftlich & Umweltfreundlich',
          content: ['Lebensdauer 5-10 Jahre;', '2-3 Mal länger als herkömmliche Materialien;', '1-2 Jahre Kostenrückgewinnung;', 'Rein anorganisch, recycelbar, null Verschmutzung.']
        }
      ],
      tableColumns: {
        productType: 'Produkttyp',
        keyParams: 'Schlüsselparameter',
        applicableScenario: 'Anwendbare Szenarien'
      },
      tableData: [
        {
          productType: 'Standard-Hochtemperatur-Isolierplatte',
          query: '950-1100℃, ≤0,04W/m-k',
          applicableScenario: 'Zementöfen, Glasöfen'
        },
        {
          productType: 'Flexible Isolierfolie/Filz',
          query: '1000-1200℃, Biegeradius ≥5cm',
          applicableScenario: 'Industrierohre, Motorabdeckungen'
        },
        {
          productType: 'Hydrophobe Isolierplatte',
          query: '1050℃, Hydrophobie ≥95%',
          applicableScenario: 'Brennstoffzellen, feuchte Öfen'
        }
      ]
    },
    servicesProduct2: {
      title: 'Aerogel-Produkteinführung',
      definition: 'Definition',
      definitionContent: 'Aerogel ist ein Nanomaterial, das durch Sol-Gel-Verfahren hergestellt wird, um die Flüssigphase zu entfernen und das poröse Netzwerk zu erhalten, mit Gas als Dispersionsmedium. Luftanteil 90%-99,8%, Porendurchmesser 1-100 Nanometer, Porosität über 90%, minimale Dichte 0,16mg/cm³, was es zu einem der leichtesten Feststoffe macht.',
      productIntro: 'Produkteinführung',
      productIntroContent: 'Interne Mikroporendurchmesser sind viel kleiner als die mittleren freien Weglängen von Luftmolekülen und blockieren Wärmeleitung und -konvektion. Anorganische Nanopartikel unterdrücken Wärmestrahlung und bilden eine "dreifache Isolationsbarriere". 100% anorganische Zusammensetzung, keine schädlichen Substanzen, umweltsicher. Verarbeitet durch Rohstoffdispersion, Kompressionsmoldung und kundenspezifische Verarbeitungsschritte.',
      performanceAdvantage: 'Leistungsvorteile',
      mainProductSystem: 'Hauptproduktsystem',
      applicationProspect: 'Anwendungsaussichten',
      applicationProspectContent: 'Aerogel nutzt mehrdimensionale Vorteile von "leicht, isolierend, stark, adsorptiv" Eigenschaften und expandiert allmählich von Luft- und Raumfahrt-Hochendanwendungen zu Bau-, Umweltschutz- und Alltagsprodukten. Derzeit mit Herausforderungen hoher Kosten und Verarbeitungsverbesserungsbedarf konfrontiert, entwickelt es sich mit Prozessoptimierung und Skalenproduktion in Richtung "hohe Leistung, niedrige Kosten, grün". Es wird eine Kernrolle bei Energieeinsparung, Emissionsreduzierung und High-End-Fertigung spielen und zu einem Schlüsselmaterial werden, das mehrere Industrien transformiert.',
      advantages: [
        {
          title: 'Ultimative Isolierung',
          content: ['Dreifache Wärmeübertragungsblockierung (Unterdrückung von Konvektion, Leitung, Strahlung);', 'Wärmeleitfähigkeit bis zu 0,015W/(m・K) bei Raumtemperatur, weit über herkömmlichen Isoliermaterialien, stabile Leistung in Hoch- und Tieftemperaturumgebungen.']
        },
        {
          title: 'Leicht aber stark',
          content: ['Extrem niedrige Dichte bei gleichzeitigen mechanischen Eigenschaften. Kohlenstoff-Aerogel kann das Tausendfache seines eigenen Gewichts tragen, faserverstärkte Typen kombinieren Flexibilität und lösen traditionelle Aerogel-Sprödigkeit.']
        },
        {
          title: 'Effiziente Adsorption & Stabilität',
          content: ['Spezifische Oberfläche von 500~3000m²/g, starke Adsorption für Schwermetalle, organische Schadstoffe, Gase mit Regenerationsfähigkeit;', 'Die meisten Typen sind säure-alkali-beständig, hochtemperaturoxidationsbeständig, mit ausgezeichneter chemischer Stabilität.']
        }
      ],
      tableColumns: {
        productType: 'Typ',
        coreCharacteristics: 'Kerneigenschaften',
        applicationDirection: 'Anwendungsrichtung'
      },
      tableData: [
        {
          productType: 'Silica-Aerogel',
          query: 'Ausgezeichnete Isolierung, moderate Kosten, chemisch stabil',
          applicableScenario: 'Gebäude-/Rohrleitungsisolierung, Geräteisolierung, Outdoor-Ausrüstung'
        },
        {
          productType: 'Kohlenstoff-Aerogel',
          query: 'Gute Leitfähigkeit, hohe Festigkeit, hochtemperaturbeständig',
          applicableScenario: 'Superkondensatoren, Öl-Wasser-Trennung, Hochtemperaturisolierung'
        },
        {
          productType: 'Metalloxid-Aerogel',
          query: 'Extrem temperaturbeständig (bis 2000℃+), gute katalytische Aktivität',
          applicableScenario: 'Flugzeugtriebwerksisolierung, Industrieöfen, Katalyse'
        },
        {
          productType: 'Metalloxid-Aerogel',
          query: 'Umweltfreundlich abbaubar, flexibel, etc.',
          applicableScenario: 'Medizinische Verbände, flexible Elektronik, komplexe Szenarioanpassung'
        }
      ]
    },
    servicesProduct3: {
      title: 'Wärmeleit-Schnittstellenmaterial (TIM) Produkteinführung',
      definition: 'Definition',
      definitionContent: 'TIM wird verwendet, um Lücken zwischen wärmeerzeugenden Komponenten und Wärmeableitungsteilen in elektronischen Geräten zu füllen, isolierende Luftspalte zu eliminieren (Luftwärmeleitfähigkeit nur 0,025W/m-K), Kontaktwärmewiderstand zu reduzieren, effiziente Wärmeleitungskanäle aufzubauen, stabilen Gerätebetrieb zu gewährleisten und die Lebensdauer zu verlängern.',
      mainTypes: 'Haupttypen',
      performanceParameters: 'Leistungsparameter',
      selectionPoints: 'Auswahlkriterien',
      tableColumns: {
        productType: 'Typ',
        typicalForm: 'Typische Form',
        characteristics: 'Eigenschaften'
      },
      tableData: [
        {
          productType: 'Wärmeleitpaste',
          query: 'Pastenflüssigkeit (enthält Wärmepartikel)',
          applicableScenario: 'Starke Füllfähigkeit, niedriger Wärmewiderstand, erfordert manuelle Anwendung, nicht klebend'
        },
        {
          productType: 'Wärmeleitpad',
          query: 'Flexibles Blatt (Silikon-/Gummisubstrat)',
          applicableScenario: 'Vorschneidbar, einfache Installation, Puffereigenschaften, teilweise mit Klebstoff'
        },
        {
          productType: 'Wärmeleitgel',
          query: 'Halbfließendes Gel',
          applicableScenario: 'Automatische Spaltfüllung, spannungsfrei, passt sich unregelmäßigen Oberflächen an'
        },
        {
          productType: 'Wärmeleitband',
          query: 'Folie mit Klebstoff',
          applicableScenario: 'Kombiniert Wärmeleitung und Verbindung, vereinfacht Montage'
        },
        {
          productType: 'Phasenwechselmaterial',
          query: 'Fest bei Raumtemperatur, schmilzt bei 40-80℃',
          applicableScenario: 'Enger Kontakt, stabiler Wärmewiderstand, kein Pump-out'
        },
        {
          productType: 'Graphen-Pad',
          query: 'Flexibles Blatt',
          applicableScenario: 'Hohe Wärmeleitfähigkeit >50W, niedriger Wärmewiderstand'
        },
        {
          productType: 'Flüssigmetall',
          query: 'Paste/Blatt',
          applicableScenario: 'Hohe Wärmeleitfähigkeit, niedriger Wärmewiderstand'
        }
      ],
      performanceParams: [
        { 
          title: 'Wärmeleitfähigkeit (K):',
          content: 'Misst Wärmeleitungsfähigkeit, Einheit W/m・K, Standard 0,5-15W/m・K, High-End 20-200W/m・K, tatsächliche Leistung durch Druck und Temperatur beeinflusst.'
        },
        { 
          title: 'Wärmewiderstand (Rθ):',
          content: 'Schlüssel-Wärmeübertragungsindikator, Einheit ℃-cm²/W, Qualitätsprodukte ≤0,1℃-cm²/W unter Standarddruck, bezogen auf Fließfähigkeit und Druck.'
        },
        { 
          title: 'Temperaturbereich:',
          content: 'Verbraucher -40℃ bis 150℃, industriell -55℃ bis 200℃, muss Erweichung, Verdampfung, Rissbildung verhindern.'
        },
        { 
          title: 'Stabilität:',
          content: 'Die meisten erfordern Isolierung (Volumenwiderstand ≥10¹²Ω・cm), Alterungsbeständigkeit (1000h Alterungsgewichtsverlust ≤3%), entsprechen RoHS-, REACH-Standards.'
        }
      ],
      selectionCriteria: [
        { 
          title: 'Wärmeanforderungen:',
          content: 'Hohe Leistung wähle ≥8W/m・K, niedrige Leistung wähle 1-3W/m・K;'
        },
        { 
          title: 'Installation:',
          content: 'Automatisierung wähle Wärmeleitband, vorgeformte Pads; unregelmäßige Oberflächen wähle Gel;'
        },
        { 
          title: 'Umgebung:',
          content: 'Hohe Temperatur wähle hitzebeständigen Typ, feuchte Bedingungen wähle hydrolysebeständigen Typ;'
        },
        { 
          title: 'Kosten:',
          content: 'Wärmeleitfähigkeit korreliert positiv mit Kosten, Balance zwischen Leistung und Budget.'
        }
      ]
    },
    servicesProduct4: {
      title: 'Wärmedämmmaterial-Produkteinführung',
      intro: 'In Bau-, Industrie-, Transport- und vielen anderen Bereichen spielen Wärmedämmmaterialien eine entscheidende Rolle. Sie sparen nicht nur effektiv Energie, sondern verbessern auch den Umweltkomfort und reduzieren Produktionskosten.',
      tabList: [
        { name: 'first', label: 'Definition und Kernfunktionen von Wärmedämmmaterialien' },
        { name: 'second', label: 'Klassifizierung von Wärmedämmmaterialien' },
        { name: 'third', label: 'Auswahlkriterien für Wärmedämmmaterialien' },
        { name: 'fourth', label: 'Entwicklungstrends von Wärmedämmmaterialien' }
      ],
      tab1: {
        definition: {
          title: 'Definition',
          content: 'Wärmedämmmaterialien, auch wärmebeständige Materialien genannt, sind Materialien, die den Wärmefluss behindern können und normalerweise eine niedrige Wärmeleitfähigkeit haben (Materialien mit einer Wärmeleitfähigkeit unter 0,05W/(m・K) werden allgemein als hocheffiziente Wärmedämmmaterialien bezeichnet).'
        },
        coreRole: {
          title: 'Kernfunktionen',
          items: [
            {
              title: '1. Energieeinsparung und Verbrauchsreduzierung:',
              content: 'Im Bauwesen reduzieren Wärmedämmmaterialien effektiv den Wärmeaustausch zwischen Gebäudeinnenräumen und -außenbereichen und senken den Energieverbrauch von Klimaanlagen und Heizgeräten.'
            },
            {
              title: '2. Verbesserung des Umweltkomforts:',
              content: 'Für Gebäude erhalten Wärmedämmmaterialien stabile Innentemperaturen und vermeiden Überhitzung im Sommer und Unterkühlung im Winter.'
            },
            {
              title: '3. Geräteschutz und Lebensdauerverlängerung:',
              content: 'Wenn Industrieanlagen und Rohrleitungen unter Hoch- oder Tieftemperaturbedingungen arbeiten, können drastische Temperaturänderungen leicht Schäden verursachen.'
            }
          ]
        }
      },
      tab2: {
        detailIntro: {
          title: 'Detaillierte Einführung',
          content: 'Basierend auf verschiedenen Materialien können Wärmedämmmaterialien hauptsächlich in drei Kategorien unterteilt werden: organische, anorganische und Verbund-Wärmedämmmaterialien.'
        },
        organicMaterials: {
          title: 'I. Organische Wärmedämmmaterialien',
          intro: 'Organische Wärmedämmmaterialien werden hauptsächlich aus organischen Polymerverbindungen hergestellt.',
          items: [
            {
              title: '1. Polystyrolschaum (EPS):',
              content: 'Leichtgewichtig mit niedriger Wärmeleitfähigkeit, geringer Wasserabsorption und Schlagfestigkeit.'
            },
            {
              title: '2. Polyurethanschaum (PU):',
              content: 'Unterteilt in starren und flexiblen Schaum. Starrer Polyurethan hat extrem niedrige Wärmeleitfähigkeit.'
            },
            {
              title: '3. Phenolschaum (PF):',
              content: 'Ausgezeichnete Hochtemperaturbeständigkeit, Flammhemmung und niedrige Rauchtoxizität.'
            }
          ]
        },
        inorganicMaterials: {
          title: 'II. Anorganische Wärmedämmmaterialien',
          intro: 'Anorganische Wärmedämmmaterialien werden hauptsächlich aus anorganischen Mineralien hergestellt.',
          items: [
            {
              title: '1. Steinwolle:',
              content: 'Hergestellt aus Basalt und Diabas durch Hochtemperaturschmelzen und Faserisierung.'
            },
            {
              title: '2. Glaswolle:',
              content: 'Hergestellt aus Quarzsand, Feldspat und Soda durch Hochtemperaturschmelzen und Faserisierung.'
            },
            {
              title: '3. Blähperlit:',
              content: 'Hergestellt aus Perlitgestein durch Zerkleinern, Vorheizen und Röstexpansion.'
            },
            {
              title: '4. Porenbeton:',
              content: 'Hergestellt aus Zement, Kalk, Sand und Flugasche mit Gasbildnern.'
            }
          ]
        },
        compositeMaterials: {
          title: 'III. Verbund-Wärmedämmmaterialien',
          intro: 'Verbund-Wärmedämmmaterialien werden durch Kombination von zwei oder mehr verschiedenen Arten von Isoliermaterialien hergestellt.',
          items: [
            {
              title: '1. Steinwolle-Polystyrol-Verbundplatte:',
              content: 'Kombiniert Steinwolle-Feuerleistung mit Polystyrolschaum-Isolierleistung.'
            },
            {
              title: '2. Glaswolle-Polyurethan-Verbundrohr:',
              content: 'Verwendet Glaswolle als Innenkern mit Polyurethanschaum als Außenschicht.'
            },
            {
              title: '3. Anorganischer Isoliermörtel-Organische Platte-Verbundsystem:',
              content: 'Verwendet normalerweise organische Isolierplatten als Wärmekern mit anorganischer Isoliermörtelbeschichtung außen.'
            }
          ]
        }
      },
      tab3: {
        detailIntro: {
          title: 'Detaillierte Einführung',
          content: 'Bei der Auswahl von Wärmedämmmaterialien müssen mehrere Faktoren umfassend berücksichtigt werden.'
        },
        thermalPerformance: {
          title: 'I. Wärmeleistung',
          content: 'Wärmeleistung ist der Kernindikator von Isoliermaterialien, normalerweise gemessen durch Wärmeleitfähigkeitskoeffizient.'
        },
        firePerformance: {
          title: 'II. Feuerleistung',
          content: 'Feuerleistung ist entscheidend, besonders im Bauwesen und an überfüllten Orten.'
        },
        mechanicalPerformance: {
          title: 'III. Mechanische Leistung',
          content: 'Mechanische Leistung umfasst hauptsächlich Druckfestigkeit, Zugfestigkeit und Biegefestigkeit.'
        },
        weatherResistance: {
          title: 'IV. Witterungsbeständigkeit und Haltbarkeit',
          content: 'Isoliermaterialien werden während der Verwendung von externen Umweltfaktoren beeinflusst.'
        },
        environmentalPerformance: {
          title: 'V. Umweltleistung',
          content: 'Mit zunehmendem Umweltbewusstsein erhält die Umweltleistung von Isoliermaterialien mehr Aufmerksamkeit.'
        },
        economicPerformance: {
          title: 'VI. Wirtschaftliche Leistung',
          content: 'Unter der Voraussetzung, dass die oben genannten Leistungsanforderungen erfüllt werden, sollte die wirtschaftliche Leistung berücksichtigt werden.'
        }
      },
      tab4: {
        detailIntro: {
          title: 'Detaillierte Einführung',
          content: 'Mit zunehmender Energiekrise und wachsendem Umweltbewusstsein entwickelt sich die Wärmedämmstoffindustrie kontinuierlich weiter.'
        },
        highEfficiencyEnergyConservation: {
          title: 'I. Hocheffiziente Energieeinsparung',
          content: 'Zukünftige Isoliermaterialien werden sich mehr auf die Verbesserung der Wärmedämmleistung konzentrieren.'
        },
        greenEnvironmentalProtection: {
          title: 'II. Grüner Umweltschutz',
          content: 'Grüner Umweltschutz wird zu einem Kerntrend in der Entwicklung von Isoliermaterialien.'
        },
        multiFunctionalization: {
          title: 'III. Multifunktionalisierung',
          content: 'Um vielfältige Bedürfnisse verschiedener Verwendungsszenarien zu erfüllen, werden sich Isoliermaterialien in Richtung Multifunktionalität entwickeln.'
        },
        lightweightThinning: {
          title: 'IV. Leichtbau und Verdünnung',
          content: 'Während Wärmedämmung und mechanische Leistung gewährleistet werden, entwickeln sich Materialien in Richtung Leichtbau und Verdünnung.'
        },
        intelligentization: {
          title: 'V. Intelligentisierung',
          content: 'Mit der Entwicklung intelligenter Gebäude und intelligenter Städte werden sich Isoliermaterialien allmählich in Richtung Intelligentisierung entwickeln.'
        }
      }
    }
  },

  // Kontakt
  contactUs: {
    bannerTitle: 'Kontakt',
    title: 'Kontaktieren Sie uns',
    zhongshanHQ: 'Hauptsitz Zhongshan',
    shanghaiHQ: 'Hauptsitz Shanghai',
    phone: 'Tel',
    email: 'E-Mail',
    address: 'Adresse',
    zhongshanPhone: '0760-88166996',
    zhongshanEmail: 'info-am@melonbean.com',
    zhongshanAddress: 'Nr.5 Dongli South Road, Torch Development Zone, Zhongshan, Guangdong',
    shanghaiPhone: '18913853555',
    shanghaiEmail: 'info-am@melonbean.com',
    shanghaiAddress: 'Raum 804, Nr.2369 Rongle East Road, Songjiang, Shanghai',
    recruit: 'Stellenangebote',
    urgent: 'Dringend',
    publishedAt: 'Veröffentlicht: ',
    resumeEmail: 'Bewerbung per E-Mail: info.asia@melonbean.com (Hinweis: Website-Rekrutierung)',
    breadcrumbContact: 'Kontakt',
    breadcrumbRecruit: 'Stellenangebote',
    job1: {
      urgent: true,
      name: 'Allgemeiner Arbeiter',
      tags: ['Shanghai', 'mind. 6 Monate Erfahrung', 'Bachelor', 'Alter 18-55'],
      date: '2025-09-20',
      requirements: 'Stellenanforderungen:',
      resume: 'Bewerbung:',
      resumeContent: 'Bewerbung per E-Mail: info.asia@melonbean.com (Hinweis: Website-Rekrutierung)',
      sections: [
        {
          title: 'I. Grundvoraussetzungen',
          content: 'Alter 18-55 Jahre, männlich oder weiblich, gute Gesundheit, keine schwerwiegenden Erkrankungen. Gültiger Personalausweis erforderlich, keine Vorstrafen, guter Charakter. Grundlegende Kommunikationsfähigkeit, Bereitschaft zur Befolgung von Arbeitsanweisungen und Einhaltung der Unternehmensregeln.',
        },
        {
          title: 'II. Stellenanforderungen',
          content: 'Keine Vorerfahrung erforderlich – kostenlose Einarbeitung wird bereitgestellt. Schnelle Lernfähigkeit für grundlegende Betriebsabläufe. Handwerkliches Geschick und Teamgeist erforderlich. Verantwortungsbewusstsein und pünktliche Aufgabenerfüllung erwartet.',
        },
        {
          title: 'III. Arbeitsdisziplin',
          content: 'Keine unentschuldigten Abwesenheiten, Verspätungen oder frühzeitiges Verlassen des Arbeitsplatzes. Einhaltung von Schichtplänen und Sicherheitsvorschriften. Persönliche Schutzausrüstung (Schutzhelm, Handschuhe, Maske) ist vorgeschrieben. Arbeitsbereich sauber halten und auf Ausrüstung achten.',
        },
        {
          title: 'IV. Bevorzugte Kandidaten',
          content: 'Kandidaten mit Erfahrung in der allgemeinen Fabrikarbeit oder Fließbandarbeit bevorzugt. Langfristige Verfügbarkeit (6+ Monate) und Bereitschaft zur Umsetzung bevorzugt. Gewissenhafte, engagierte Kandidaten mit positiver Arbeitseinstellung bevorzugt.',
        },
      ],
    },
    job2: {
      urgent: true,
      name: 'Kernarbeiter / Schlüsseltechniker',
      tags: ['Shanghai', 'männlich/weiblich', 'mind. 3 Jahre Erfahrung', 'Bachelor oder höher'],
      date: '2025-09-20',
      sections: [
        {
          title: 'I. Stellenverantwortlichkeiten:',
          items: [
            'Verantwortlich für den täglichen Betrieb, die Prozessausführung und Qualitätskontrolle wichtiger Produktionsprozesse',
            'Kernausrüstung sicher und stabil betreiben',
            'Produktionsaufgaben gemäß Prozessdokumenten und Arbeitsanweisungen erfüllen',
            'An der Analyse von Produktionsanomalien teilnehmen und Verbesserungsvorschläge machen',
            'Bei der Einarbeitung neuer Mitarbeiter helfen und als technischer Mentor fungieren',
            'Mit Prozess-, Qualitäts- und Ausrüstungsabteilungen bei Verbesserungen zusammenarbeiten',
            'Sicherheits-, 5S- und Unternehmensvorschriften strikt einhalten',
          ],
        },
        {
          title: 'II. Anforderungen:',
          groups: [
            { label: 'Ausbildung:', lines: ['Bachelor oder höher', 'Maschinenbau, Mechatronik, Automatisierung, Werkstofftechnik oder Industrieingenieurwesen bevorzugt'] },
            { label: 'Erfahrung:', lines: ['Mind. 3 Jahre Erfahrung in der Fertigung', 'Erfahrung mit Schlüsselprozessen und Kernausrüstung bevorzugt', 'Erfahrung als Teamleiter oder Mentor bevorzugt'] },
            { label: 'Fähigkeiten:', lines: ['Vertraut mit Produktionsprozessen, starke praktische Fähigkeiten', 'Fähig, häufige Produktionsanomalien selbstständig zu beheben', 'Verantwortungsbewusstsein, hohe Ausführungskraft, Schichtbereitschaft', 'Gute Kommunikations- und Teamarbeitsfähigkeiten'] },
          ],
        },
        {
          title: 'III. Zusätzliche Qualifikationen:',
          items: [
            'Kenntnisse automatisierter Produktionslinien oder CNC-Anlagen',
            'Erfahrung mit Prozessverbesserung oder Kostensenkungsprojekten',
            'Grundlegende Kenntnisse zur Gerätewartung',
            'Erfahrung mit Lean Production, TPM oder Six Sigma',
          ],
        },
        {
          title: 'IV. Karriereentwicklung:',
          items: [
            'Kernarbeiter → Technischer Experte → Teamleiter / Prozesstechniker',
            'Herausragende Mitarbeiter können in das Produktions- oder technische Management wechseln',
          ],
        },
        {
          title: 'V. Vergütung & Benefits:',
          items: [
            'Gehalt: verhandelbar (kompetenzbasiert)',
            'Sozialversicherung & private Krankenversicherung',
            'Jahresbonus, Fachkräftezulage, Überstundenvergütung',
            'Unterkunft / Mahlzeiten / Urlaubsleistungen',
          ],
        },
      ],
      resume: 'Bewerbung:',
      resumeContent: 'Bewerbung per E-Mail: info.asia@melonbean.com (Hinweis: Website-Rekrutierung)',
    },
    job3: {
      urgent: true,
      name: 'Vertriebsmitarbeiter / Regionaler Vertriebsspezialist',
      tags: ['Shanghai', 'männlich/weiblich', 'mind. 3 Jahre Erfahrung', 'Bachelor oder höher'],
      date: '2025-09-20',
      sections: [
        {
          title: 'I. Stellenverantwortlichkeiten:',
          items: [
            'Markterschließung und Kundenentwicklung in zugewiesenen Regionen oder Branchen, Aufbau stabiler Kundenpartnerschaften',
            'Pflege bestehender Kundenbeziehungen, regelmäßige Kundenbesuche und Bedarfsanalysen',
            'Individuelle Verkaufspläne entwickeln und den gesamten Verkaufszyklus abwickeln',
            'Auftragserfüllung verfolgen und interne Abteilungen koordinieren',
            'Marktinformationen und Wettbewerbsanalysen sammeln und berichten',
            'An Verkaufsförderungsaktionen, Messen und Branchenveranstaltungen teilnehmen',
            'Verkaufspolitik strikt einhalten und pünktliche Zahlungseingänge sicherstellen',
          ],
        },
        {
          title: 'II. Anforderungen:',
          groups: [
            { label: 'Ausbildung:', lines: ['Bachelor oder höher', 'Werkstofftechnik, Chemieingenieurwesen, Elektronik bevorzugt'] },
            { label: 'Erfahrung:', lines: ['Mind. 3 Jahre Vertriebserfahrung im B2B/B2C-Bereich; Elektronik oder Materialbranche bevorzugt', 'Nachgewiesene Erfolge bei Marktentwicklung und Leistungszielen bevorzugt', 'Erfahrung in Teamarbeit, Account-Management oder Mentoring bevorzugt'] },
            { label: 'Fähigkeiten:', lines: ['Kenntnisse des gesamten Vertriebsprozesses, ausgeprägte Marktkenntnis', 'Ausgezeichnete Kommunikations-, Verhandlungs- und Problemlösungsfähigkeiten', 'Zielorientiert, belastbar, starke Ausführungskraft', 'Gute Berufsethik, Integrität und Teamgeist'] },
          ],
        },
        {
          title: 'III. Zusätzliche Qualifikationen:',
          items: [
            'Produktkenntnisse der Branche, technischer oder lösungsorientierter Vertrieb',
            'Erfahrung in der Entwicklung und Betreuung von Großkunden',
            'Grundlegende Marktanalyse- und Strategieentwicklungsfähigkeiten',
            'Führerschein und Erfahrung in regionaler Marktentwicklung',
          ],
        },
        {
          title: 'IV. Karriereentwicklung:',
          items: [
            'Hauptpfad: Vertriebsmitarbeiter → Senior Sales → Vertriebsleiter / Regionaler Vertriebsmanager',
            'Herausragende Mitarbeiter können in Vertriebsmanagement oder Marketing wechseln',
          ],
        },
        {
          title: 'V. Vergütung & Benefits:',
          items: [
            'Gehalt: verhandelbar (Grundgehalt + hohe Provision + Leistungsbonus, keine Obergrenze)',
            'Sozialversicherung & private Krankenversicherung',
            'Jahresbonus, Reisekostenerstattung, Kommunikationszulage, Reisekostenzulage, Urlaubsgeschenke',
            'Mahlzeiten/Essenszulage, Teambuilding, jährliche Gesundheitsuntersuchung, bezahlter Jahresurlaub',
          ],
        },
      ],
      resume: 'Bewerbung:',
      resumeContent: 'Bewerbung per E-Mail: info.asia@melonbean.com (Hinweis: Website-Rekrutierung)',
    },
    job4: {
      urgent: true,
      name: 'IT-Betriebsingenieur (Fabrik)',
      tags: ['Shanghai', 'männlich/weiblich', 'mind. 3 Jahre Erfahrung', 'Bachelor oder höher'],
      date: '2025-09-20',
      sections: [
        {
          title: 'I. Stellenverantwortlichkeiten:',
          items: [
            'Täglicher Betrieb und Wartung von Fabrikservern, Netzwerkgeräten, industriellen Steuerungsterminals und Produktionslinen-IT-Systemen (MES/ERP/SCADA), 7x24 Betrieb sicherstellen',
            'IT-Geräteinspektion, Datensicherung, Schwachstellenbehebung und Wartungspläne entwickeln und umsetzen',
            'Schnell auf IT-Störungen, Gerätewarnungen und Mitarbeiteranfragen reagieren; Fehlerdiagnose und -behebung durchführen; Fehleranalyseberichte erstellen',
            'An IT-Infrastrukturerweiterungen und industrieller Netzwerkoptimierung teilnehmen; MES/SCADA-Bereitstellung unterstützen',
            'Standardisierung von IT-Betriebsprozessen vorantreiben; Notfallpläne für industrielle Steuerungssysteme entwickeln',
            'F&E- und Prozessabteilungen bei neuen Produktionslinien und Systemversions-Iterationen unterstützen',
            'Vollständiges Lebenszyklusmanagement von Fabrik-IT-Assets; Informations- und Steuerungssicherheitsrichtlinien umsetzen',
          ],
        },
        {
          title: 'II. Anforderungen:',
          groups: [
            { label: 'Ausbildung:', lines: ['Bachelor oder höher', 'Informatik, Netzwerktechnik, Informationssicherheit, industrielle Automatisierung bevorzugt'] },
            { label: 'Erfahrung:', lines: ['Mind. 3 Jahre Fabrik-IT- oder Steuerungs-IT-Erfahrung; Fertigungsbranche bevorzugt', 'Erfahrung mit Fabrikservern, industriellen Netzwerken, MES/ERP/SCADA bevorzugt', 'Erfahrung in Notfallbehebung und abteilungsübergreifender Zusammenarbeit bevorzugt'] },
            { label: 'Fähigkeiten:', lines: ['Kenntnisse in Windows/Linux-Betrieb, Netzwerkkonfiguration und mindestens einem Industriesteuerungssystem', 'Fundierte Kenntnisse in Computernetzwerken und industrieller Steuerungssicherheit', 'Starkes Servicebewusstsein; Schichtbereitschaft und Notfallbereitschaft', 'Gute abteilungsübergreifende Kommunikationsfähigkeiten'] },
          ],
        },
        {
          title: 'III. Zusätzliche Qualifikationen:',
          items: [
            'Kenntnisse der PLC-Grundlagen, industriellen Ethernet-Konfiguration',
            'Erfahrung in IT-Prozessoptimierung, Steuerungssicherheits-Härtung oder Backup-Lösungen',
            'Kenntnisse in Virtualisierung, Containerisierung oder Cloud-Plattformen',
            'Zertifizierungen von Alibaba Cloud, Huawei Cloud oder gleichwertigen Anbietern',
          ],
        },
        {
          title: 'IV. Karriereentwicklung:',
          items: [
            'Technischer Pfad: IT-Betriebsingenieur → Senior O&M-Ingenieur → Steuerungsexperte / IT-Architekt',
            'Managementpfad: Herausragende Mitarbeiter können IT-Supervisor oder O&M-Manager werden',
          ],
        },
        {
          title: 'V. Vergütung & Benefits:',
          items: [
            'Gehalt: verhandelbar (Festgehalt + Leistungsbonus + Produktionssicherungsbonus)',
            'Sozialversicherung & private Krankenversicherung',
            'Jahresbonus, O&M-Zulage, Schicht-/Überstundenvergütung, Transport- & Kommunikationszulage',
            'Werkswohnheim / Mahlzeiten, Teambuilding, jährliche Gesundheitsuntersuchung, bezahlter Jahresurlaub',
          ],
        },
      ],
      resume: 'Bewerbung:',
      resumeContent: 'Bewerbung per E-Mail: info.asia@melonbean.com (Hinweis: Website-Rekrutierung)',
    },
    job5: {
      urgent: true,
      name: 'Vertriebsmitarbeiter (Junior)',
      tags: ['Shanghai', 'Alter 20-40', 'männlich/weiblich', 'Abitur oder höher'],
      date: '2025-09-20',
      sections: [
        {
          title: 'Stellenanforderungen:',
          groups: [
            {
              label: 'I. Grundvoraussetzungen',
              lines: ['Alter 20-40 Jahre, männlich oder weiblich, Abitur oder höher, gute Gesundheit, keine schlechten Gewohnheiten, Reisebereitschaft. Gültiger Personalausweis, keine Vorstrafen, guter Charakter. Klare Kommunikations- und Denkfähigkeiten. Identifikation mit der Unternehmenskultur und langfristige Arbeitsverpflichtung.'],
            },
            {
              label: 'II. Kernaufgaben',
              lines: ['Branchenerfahrung: mind. 1 Jahr Vertriebserfahrung im Elektronikbereich.', 'Produktkenntnisse: Kernspezifikationen schnell erfassen und Kundenlösungen anbieten.', 'Kundenentwicklung: Neukunden durch Anrufe, Besuche und Messen gewinnen.', 'Vertriebsausführung: gesamten Verkaufszyklus selbstständig abwickeln und individuelle Verkaufsziele erreichen.', 'Tools: Office-Software (Excel, Word, PPT) und WeChat/WeCom beherrschen.'],
            },
            {
              label: 'III. Arbeitseinstellung',
              lines: ['Belastbar; positiver Umgang mit Leistungsdruck und Ablehnung.', 'Verantwortungsbewusst; reaktionsschnell gegenüber Kunden und Auftragslieferung.', 'Teamorientiert; teilt Brancheninformationen und Verkaufstipps aktiv.', 'Lernbereit; verfolgt Branchentrends und Wettbewerberinformationen.'],
            },
            {
              label: 'IV. Bevorzugte Kandidaten',
              lines: ['Vertriebserfahrung in Elektronikkomponenten, Unterhaltungselektronik oder Industriegeräten bevorzugt.', 'Bestehende Kundenkontakte bevorzugt.', 'Technischer Hintergrund im Elektronikbereich bevorzugt.', 'Gesellige Persönlichkeit, stark in Verhandlung und Kundenbeziehungen bevorzugt.'],
            },
          ],
        },
      ],
      resume: 'Bewerbung:',
      resumeContent: 'Bewerbung per E-Mail: info.asia@melonbean.com (Hinweis: Website-Rekrutierung)',
    },
    job6: {
      urgent: true,
      name: 'IT-Betriebsingenieur (Fabrik)',
      tags: ['Shanghai', 'Alter 22-38', 'männlich/weiblich', 'Bachelor oder höher'],
      date: '2025-09-20',
      sections: [
        {
          title: 'Stellenanforderungen:',
          groups: [
            {
              label: 'I. Grundvoraussetzungen',
              lines: ['Alter 22-38 Jahre, Bachelor oder höher; Informatik, Netzwerktechnik, Automatisierung bevorzugt. Gültiger Personalausweis, keine Vorstrafen, strikte Vertraulichkeit von Fabrikdaten. Starke Problemanalyse- und Notfallbewältigungsfähigkeiten. Gute abteilungsübergreifende Kommunikationsfähigkeiten. Schichtbereitschaft und Belastbarkeit.'],
            },
            {
              label: 'II. Kernaufgaben',
              lines: ['Fabrik-Netzwerk-O&M: TCP/IP-Kenntnisse; selbstständiger Aufbau und Wartung von Fabrik-LANs und IoT-Netzwerken; Router, Switches und Firewalls konfigurieren; Netzwerkanomalien schnell diagnostizieren.', 'Industriegeräte-O&M: Kenntnisse in PLC, SCADA, MES; Unterstützung bei Gerätvernetzung, Datenerfassung und Systemintegration.', 'Server- und System-O&M: Linux (CentOS, Ubuntu) und Windows Server; Server-/Datenbank-Installation, Backup, Optimierung und Fehlerbehebung.', 'Endgeräte-O&M: Fehlerdiagnose und -behebung bei PCs, Produktionsterminals, Druckern und Scannern.', 'Automatisierung & Monitoring: Shell- oder Python-Skriptkenntnisse; Zabbix oder ähnliche Monitoring-Tools; Fabrik-IT-Überwachungssystem aufbauen.', 'Sicherheitsmanagement: Kenntnisse in industrieller Netzwerksicherheit; Unterstützung bei IT-Sicherheitsrichtlinien.'],
            },
            {
              label: 'III. Berufserfahrung',
              lines: ['1-3+ Jahre Fabrik- oder Fertigungs-IT-O&M-Erfahrung; Vertrautheit mit Produktionsprozessen bevorzugt.', 'Erfahrung mit MES-, ERP- oder WMS-Systemen bevorzugt.', 'Erfahrung in Notfallbehebung bei Produktionsausfällen bevorzugt.'],
            },
            {
              label: 'IV. Arbeitseinstellung',
              lines: ['Hochgradig verantwortungsbewusst; proaktive Risikoidentifikation und -prävention.', 'Kontinuierlicher Lerner; verfolgt neue Technologien im Bereich Industrie 4.0.', 'Gewissenhaft; strikte Einhaltung von Prozessen bei Konfigurationsänderungen und Software-Upgrades.', 'Starkes Servicebewusstsein; schnelle und geduldige Reaktion auf IT-Anfragen.'],
            },
            {
              label: 'V. Bevorzugte Kandidaten',
              lines: ['CCNA/CCNP, industrielle Internetzertifizierung oder Alibaba Cloud ACP bevorzugt.', 'Kenntnisse in Docker, Kubernetes oder IoT-Plattformen bevorzugt.', 'Erfahrung in großen Fertigungsfabriken oder Verwaltung ganzer Produktionslinen-IT bevorzugt.', 'Elektrotechnik-Automatisierungskenntnisse bevorzugt.'],
            },
          ],
        },
      ],
      resume: 'Bewerbung:',
      resumeContent: 'Bewerbung per E-Mail: info.asia@melonbean.com (Hinweis: Website-Rekrutierung)',
    },
    jobs: [
      {
        urgent: true,
        jobName: 'Allgemeiner Arbeiter',
        requireList: ['Shanghai', 'mind. 6 Monate Erfahrung', 'Bachelor'],
        createDate: '2025-09-20',
      },
      {
        urgent: true,
        jobName: 'Kernarbeiter / Schlüsseltechniker',
        requireList: ['Shanghai', 'mind. 3 Jahre Erfahrung', 'Bachelor oder höher'],
        createDate: '2025-09-20',
      },
      {
        urgent: true,
        jobName: 'Vertriebsmitarbeiter',
        requireList: ['Shanghai', 'mind. 3 Jahre Erfahrung', 'Bachelor oder höher'],
        createDate: '2025-09-20',
      },
      {
        urgent: true,
        jobName: 'IT-Betriebsingenieur (Fabrik)',
        requireList: ['Shanghai', 'mind. 3 Jahre Erfahrung', 'Bachelor oder höher'],
        createDate: '2025-09-20',
      },
      {
        urgent: true,
        jobName: 'Vertriebsmitarbeiter (Junior)',
        requireList: ['Shanghai', 'Alter 20-40', 'Abitur oder höher'],
        createDate: '2025-09-20',
      },
      {
        urgent: true,
        jobName: 'IT-Betriebsingenieur (Fabrik)',
        requireList: ['Shanghai', 'Alter 22-38', 'Bachelor oder höher'],
        createDate: '2025-09-20',
      },
    ],
  },
}
